  // Removed skeleton loading function - using pagination instead
(function() {
   // TrustBox script
   if (!document.querySelector('script[src*="tp.widget.bootstrap.min.js"]')) {
    const trustpilotScript = document.createElement('script');
    trustpilotScript.type = 'text/javascript';
    trustpilotScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    trustpilotScript.async = true;
    document.head.appendChild(trustpilotScript);
  }

  var hooksRegistered = false;

  // Persist InstantSearch filter query params across refresh.
  // InstantSearch can strip refinementList from the URL on dispose before reload;
  // restore from sessionStorage before InstantSearch reads location.
  // Filters are scoped to the search query (q): changing q wipes them.
  const LAST_APPLIED_FILTERS_KEY = "LastAppliedFilters";
  const HAS_APPLIED_FILTER_LAST_TIME_KEY = "HasAppliedFilterLastTime";
  const LAST_APPLIED_FILTER_QUERY_KEY = "LastAppliedFilterQuery";
  const NON_FILTER_SEARCH_PARAMS = new Set([
    "q",
    "type",
    "options[prefix]",
    "options%5Bprefix%5D",
  ]);

  /**
   * @returns {boolean}
   */
  function isAlgoliaSearchPage() {
    const { pathname } = window.location;
    return pathname === "/search" || pathname.endsWith("/search");
  }

  /**
   * @param {string} [search]
   * @returns {string}
   */
  function getAlgoliaSearchQuery(search) {
    const params = new URLSearchParams(
      (search || window.location.search).replace(/^\?/, "")
    );
    return String(params.get("q") || "").trim().toLowerCase();
  }

  /**
   * @param {string} search
   * @returns {URLSearchParams}
   */
  function getAlgoliaFilterParams(search) {
    const params = new URLSearchParams(
      search.charAt(0) === "?" ? search.slice(1) : search
    );
    const filters = new URLSearchParams();
    params.forEach((value, key) => {
      if (NON_FILTER_SEARCH_PARAMS.has(key)) return;
      filters.append(key, value);
    });
    return filters;
  }

  /**
   * @param {URLSearchParams} filterParams
   * @returns {boolean}
   */
  function hasAlgoliaFilterParams(filterParams) {
    return Array.from(filterParams.keys()).length > 0;
  }

  /**
   * @returns {void}
   */
  function clearStoredAlgoliaFilters() {
    try {
      sessionStorage.setItem(HAS_APPLIED_FILTER_LAST_TIME_KEY, "false");
      sessionStorage.removeItem(LAST_APPLIED_FILTERS_KEY);
      sessionStorage.removeItem(LAST_APPLIED_FILTER_QUERY_KEY);
    } catch (e) {
      console.error("Error clearing stored Algolia filters:", e);
      // ponytail: sessionStorage may be blocked in private mode
    }
  }

  /**
   * Remove InstantSearch filter params from the URL and clear helper refinements.
   * @returns {void}
   */
  function wipeAlgoliaFiltersForQueryChange() {
    clearStoredAlgoliaFilters();

    try {
      const next = new URL(window.location.href);
      const filterParams = getAlgoliaFilterParams(next.search);
      if (hasAlgoliaFilterParams(filterParams)) {
        Array.from(filterParams.keys()).forEach((key) => {
          next.searchParams.delete(key);
        });
        window.history.replaceState(
          window.history.state,
          "",
          next.pathname + next.search + next.hash
        );
      }
    } catch (e) {
      console.error("Error wiping Algolia filters for query change:", e);
    }

    try {
      const helper = window.algoliaShopify?.instantsearch?.search?.helper;
      if (helper && helperHasAnyRefinements(helper.state)) {
        if (typeof helper.clearRefinements === "function") {
          helper.clearRefinements();
        }
        helper.search();
      }
    } catch (e) {
      console.error("Error clearing Algolia helper refinements:", e);
    }
  }

  /**
   * Sync LastAppliedFilters / HasAppliedFilterLastTime from the current URL.
   * @param {{ allowClear?: boolean }} [opts]
   * @returns {void}
   */
  function syncAlgoliaFiltersToLocalStorage(opts) {
    if (!isAlgoliaSearchPage()) return;
    const allowClear = !opts || opts.allowClear !== false;
    try {
      const currentQuery = getAlgoliaSearchQuery();
      const storedQuery = String(
        sessionStorage.getItem(LAST_APPLIED_FILTER_QUERY_KEY) || ""
      ).trim().toLowerCase();

      // New search term → drop filters from the previous query.
      if (
        storedQuery &&
        currentQuery !== storedQuery &&
        sessionStorage.getItem(HAS_APPLIED_FILTER_LAST_TIME_KEY) === "true"
      ) {
        wipeAlgoliaFiltersForQueryChange();
        return;
      }

      const filterParams = getAlgoliaFilterParams(window.location.search);
      const applied = hasAlgoliaFilterParams(filterParams);
      if (applied) {
        sessionStorage.setItem(HAS_APPLIED_FILTER_LAST_TIME_KEY, "true");
        sessionStorage.setItem(LAST_APPLIED_FILTERS_KEY, filterParams.toString());
        sessionStorage.setItem(LAST_APPLIED_FILTER_QUERY_KEY, currentQuery);
        return;
      }
      // Avoid wiping stored filters while InstantSearch hydrates / disposes.
      if (!allowClear) return;
      clearStoredAlgoliaFilters();
    } catch (e) {
      console.error("Error syncing Algolia filters to sessionStorage:", e);
      // ponytail: sessionStorage may be blocked in private mode
    }
  }

  /**
   * If HasAppliedFilterLastTime is true, append LastAppliedFilters to the URL.
   * Only restores when the current q matches the query those filters were saved for.
   * @returns {boolean}
   */
  function appendStoredAlgoliaFiltersToUrl() {
    if (!isAlgoliaSearchPage()) return false;
    try {
      const hasApplied =
        sessionStorage.getItem(HAS_APPLIED_FILTER_LAST_TIME_KEY) === "true";
      if (!hasApplied) return false;

      const stored = sessionStorage.getItem(LAST_APPLIED_FILTERS_KEY) || "";
      if (!stored) return false;

      const currentQuery = getAlgoliaSearchQuery();
      const storedQuery = String(
        sessionStorage.getItem(LAST_APPLIED_FILTER_QUERY_KEY) || ""
      ).trim().toLowerCase();
      if (!storedQuery || currentQuery !== storedQuery) {
        clearStoredAlgoliaFilters();
        return false;
      }

      const currentFilters = getAlgoliaFilterParams(window.location.search);
      if (hasAlgoliaFilterParams(currentFilters)) {
        syncAlgoliaFiltersToLocalStorage({ allowClear: false });
        return false;
      }

      const next = new URL(window.location.href);
      new URLSearchParams(stored).forEach((value, key) => {
        next.searchParams.append(key, value);
      });

      window.history.replaceState(
        window.history.state,
        "",
        next.pathname + next.search + next.hash
      );
      return true;
    } catch (e) {
      console.error("Error appending stored filters to URL", e);
      return false;
    }
  }

  /**
   * @param {object} helperState
   * @returns {boolean}
   */
  function helperHasFacetRefinements(helperState) {
    if (!helperState) return false;
    const groups = [
      helperState.disjunctiveFacetsRefinements,
      helperState.facetsRefinements,
      helperState.hierarchicalFacetsRefinements,
    ];
    return groups.some((group) => {
      if (!group || typeof group !== "object") return false;
      return Object.keys(group).some((key) => {
        const values = group[key];
        return Array.isArray(values) ? values.length > 0 : Boolean(values);
      });
    });
  }

  /**
   * @param {object} helperState
   * @returns {boolean}
   */
  function helperHasNumericRefinements(helperState) {
    const numeric = helperState && helperState.numericRefinements;
    if (!numeric || typeof numeric !== "object") return false;
    return Object.keys(numeric).some((attribute) => {
      const ops = numeric[attribute];
      if (!ops || typeof ops !== "object") return false;
      return Object.keys(ops).some((op) => {
        const values = ops[op];
        return Array.isArray(values) ? values.length > 0 : values != null;
      });
    });
  }

  /**
   * @param {object} helperState
   * @returns {boolean}
   */
  function helperHasAnyRefinements(helperState) {
    return (
      helperHasFacetRefinements(helperState) ||
      helperHasNumericRefinements(helperState)
    );
  }

  /**
   * Apply one stored InstantSearch URL param to the helper (refinementList + range).
   * Skips values already present so mixed facet+price restores stay intact.
   * @param {object} helper
   * @param {string} key
   * @param {string} value
   * @returns {boolean}
   */
  function applyStoredFilterParamToHelper(helper, key, value) {
    const state = helper.state || {};

    const refinementMatch = key.match(/^refinementList\[(.+?)\](?:\[\d+\])?$/);
    if (refinementMatch) {
      const attribute = refinementMatch[1];
      const existing =
        (state.disjunctiveFacetsRefinements &&
          state.disjunctiveFacetsRefinements[attribute]) ||
        (state.facetsRefinements && state.facetsRefinements[attribute]) ||
        [];
      if (Array.isArray(existing) && existing.map(String).includes(String(value))) {
        return false;
      }
      if (typeof helper.addDisjunctiveFacetRefinement === "function") {
        helper.addDisjunctiveFacetRefinement(attribute, value);
        return true;
      }
      return false;
    }

    // range[price]=10:50  (empty bound allowed, e.g. ":50" or "10:")
    const rangeMatch = key.match(/^range\[(.+?)\]$/);
    if (rangeMatch) {
      const attribute = rangeMatch[1];
      const parts = String(value).split(":");
      const min = parts[0];
      const max = parts.length > 1 ? parts[1] : "";
      const numeric =
        (state.numericRefinements && state.numericRefinements[attribute]) || {};
      let applied = false;
      if (min !== "" && !Number.isNaN(Number(min))) {
        const existingMin = numeric[">="] || numeric[">"] || [];
        if (!Array.isArray(existingMin) || !existingMin.map(Number).includes(Number(min))) {
          helper.addNumericRefinement(attribute, ">=", Number(min));
          applied = true;
        }
      }
      if (max !== "" && !Number.isNaN(Number(max))) {
        const existingMax = numeric["<="] || numeric["<"] || [];
        if (!Array.isArray(existingMax) || !existingMax.map(Number).includes(Number(max))) {
          helper.addNumericRefinement(attribute, "<=", Number(max));
          applied = true;
        }
      }
      return applied;
    }

    // range[price][min]=10 / range[price][max]=50
    const rangeBoundMatch = key.match(/^range\[(.+?)\]\[(min|max)\]$/);
    if (rangeBoundMatch) {
      const attribute = rangeBoundMatch[1];
      const bound = rangeBoundMatch[2];
      if (value === "" || Number.isNaN(Number(value))) return false;
      const op = bound === "min" ? ">=" : "<=";
      const numeric =
        (state.numericRefinements && state.numericRefinements[attribute]) || {};
      const existing = numeric[op] || [];
      if (Array.isArray(existing) && existing.map(Number).includes(Number(value))) {
        return false;
      }
      helper.addNumericRefinement(attribute, op, Number(value));
      return true;
    }

    return false;
  }

  /**
   * Apply stored refinementList + range params to InstantSearch when URL restore
   * alone did not hydrate helper/UI state (common after refresh).
   * @returns {boolean}
   */
  function applyStoredFiltersToInstantSearchHelper() {
    if (!isAlgoliaSearchPage()) return false;
    try {
      if (sessionStorage.getItem(HAS_APPLIED_FILTER_LAST_TIME_KEY) !== "true") {
        return false;
      }
      const stored = sessionStorage.getItem(LAST_APPLIED_FILTERS_KEY) || "";
      if (!stored) return false;

      const currentQuery = getAlgoliaSearchQuery();
      const storedQuery = String(
        sessionStorage.getItem(LAST_APPLIED_FILTER_QUERY_KEY) || ""
      ).trim().toLowerCase();
      if (!storedQuery || currentQuery !== storedQuery) {
        clearStoredAlgoliaFilters();
        return false;
      }

      const search = window.algoliaShopify?.instantsearch?.search;
      const helper = search?.helper;
      if (!helper) return false;

      appendStoredAlgoliaFiltersToUrl();

      let applied = false;
      new URLSearchParams(stored).forEach((value, key) => {
        if (applyStoredFilterParamToHelper(helper, key, value)) {
          applied = true;
        }
      });

      if (!applied) {
        // Nothing missing — stored filters already reflected in helper/UI.
        return helperHasAnyRefinements(helper.state);
      }
      helper.search();
      return true;
    } catch (_) {
      return false;
    }
  }

  /**
   * @returns {void}
   */
  function scheduleStoredFilterEnforcement() {
    if (!isAlgoliaSearchPage()) return;
    let attempts = 0;
    const maxAttempts = 40;
    const tick = () => {
      attempts += 1;
      if (applyStoredFiltersToInstantSearchHelper()) return;
      if (attempts >= maxAttempts) return;
      window.setTimeout(tick, 100);
    };
    window.setTimeout(tick, 0);
  }

  (function bindAlgoliaFilterUrlPersistence() {
    let allowClearSync = false;
    let isUnloading = false;

    // ponytail: InstantSearch can briefly rewrite URL without refinements on boot;
    // delay treating "no filters" as an intentional clear.
    window.setTimeout(() => {
      allowClearSync = true;
      syncAlgoliaFiltersToLocalStorage({ allowClear: true });
    }, 1500);

    appendStoredAlgoliaFiltersToUrl();
    syncAlgoliaFiltersToLocalStorage({ allowClear: false });

    /**
     * @returns {void}
     */
    const syncFromHistory = () => {
      if (isUnloading) {
        if (hasAlgoliaFilterParams(getAlgoliaFilterParams(window.location.search))) {
          syncAlgoliaFiltersToLocalStorage({ allowClear: false });
        }
        return;
      }
      syncAlgoliaFiltersToLocalStorage({ allowClear: allowClearSync });
    };

    /**
     * @param {"pushState"|"replaceState"} methodName
     * @returns {void}
     */
    const wrapHistoryMethod = (methodName) => {
      const original = window.history[methodName];
      if (typeof original !== "function") return;
      window.history[methodName] = function (...args) {
        const result = original.apply(this, args);
        queueMicrotask(syncFromHistory);
        return result;
      };
    };

    wrapHistoryMethod("pushState");
    wrapHistoryMethod("replaceState");
    // INP risk: low — reads URL + writes sessionStorage; no layout reads.
    window.addEventListener("popstate", syncFromHistory);
    window.addEventListener("beforeunload", () => {
      isUnloading = true;
    });
    window.addEventListener("pagehide", () => {
      isUnloading = true;
      if (!isAlgoliaSearchPage()) return;
      if (hasAlgoliaFilterParams(getAlgoliaFilterParams(window.location.search))) {
        syncAlgoliaFiltersToLocalStorage({ allowClear: false });
      }
    });
  })();

  function resolveAlgoliaItemColor(item) {
    if (!item) return "";

    const normalize = (value) =>
      typeof value === "string" ? value.trim() : "";
    const firstNonEmpty = (values) => {
      for (const value of values) {
        const normalized = normalize(value);
        if (normalized) return normalized;
      }
      return "";
    };

    let color = firstNonEmpty([
      item?.options?.colour,
      item?.options?.color,
      item?.option1,
      item?.variant_option_1,
      item?.color,
      item?.colour,
    ]);

    if (!color && Array.isArray(item?.options)) {
      const colorOptionObj = item.options.find((opt) =>
        /colou?r/i.test(normalize(opt?.name || opt?.label || ""))
      );
      if (colorOptionObj) {
        color = firstNonEmpty([
          colorOptionObj.value,
          Array.isArray(colorOptionObj.values) ? colorOptionObj.values[0] : "",
        ]);
      }
    }

    if (!color) {
      const variantTitle = normalize(item?.variant_title);
      if (variantTitle && variantTitle.toLowerCase() !== "default title") {
        color = normalize(variantTitle.split("/")[0].split("(")[0]);
      }
    }

    return color;
  }

  let ImageDefaultAlt = false;

  function parseBoolLike(value) {
    if (value === true || value === 1 || value === "1") return true;
    if (value === false || value === 0 || value === "0") return false;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "yes") return true;
      if (normalized === "false" || normalized === "no" || normalized === "") return false;
    }
    return false;
  }

  function getOriginalImageAltFromItem(item) {
    if (!item) return "";
    const pickFirstNonEmpty = (values) => {
      for (const value of values) {
        if (typeof value === "string" && value.trim()) return value.trim();
      }
      return "";
    };
    return pickFirstNonEmpty([
      item?.image_alt,
      item?.imageAlt,
      item?.alt,
      item?.image?.alt,
      item?.featured_image?.alt,
      item?.featuredImage?.alt,
      item?.media?.alt,
    ]);
  }

  function buildAlgoliaImageAlt(item) {
    const title =
      (typeof item?.title === "string" && item.title.trim()) ||
      (typeof item?.name === "string" && item.name.trim()) ||
      "Product";
    const color = resolveAlgoliaItemColor(item);

    const candidates = [
      item?.image_position,
      item?.imagePosition,
      item?.position,
      item?._position,
      item?.productPosition,
      item?.image_index,
      item?.imageIndex,
      item?.image_position_index,
      item?.imagePositionIndex,
      1,
    ];

    let imagePosition = 1;
    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        imagePosition = Math.floor(parsed);
        break;
      }
    }

    return `${title} in ${color} - Image ${imagePosition}`;
  }

  try {
    window.buildAlgoliaImageAlt = buildAlgoliaImageAlt;
  } catch (_) {}

  // Function to get dynamic collections from custom section for search panel
  function getDynamicCollections(html) {
    try {
      // Try to get collections from the search panel collections section
      const customSection = document.querySelector('.search-panel-collections-section');
      
      if (customSection) {
        const collectionCards = customSection.querySelectorAll('.collection-card');
        
        if (collectionCards.length > 0) {
          // Store count for header
          const customCollectionsCount = collectionCards.length;
          
          // Create collection cards using html template literal properly
          const collectionElements = Array.from(collectionCards).map(card => {
            const image = card.querySelector('.collection-image');
            const title = card.querySelector('.collection-title');
            const linkHref = card.href || '#';
            
            const imageSrc = image ? image.src : '';
            const imageAlt = image ? image.alt : '';
            const titleText = title ? title.textContent : '';
            
            return html`
              <a href="${linkHref}" class="collection-card">
                <div class="collection-image-container">
                  <img src="${imageSrc}" alt="${imageAlt}" class="collection-image" />
                </div>
                <div class="collection-content">
                  <h3 class="collection-title">${titleText}</h3>
                </div>
              </a>
            `;
          });
          
          return {
            html: html`<div class="custom-collections-grid">${collectionElements}</div>`,
            count: customCollectionsCount
          };
        }
      }
      
      // Fallback to default collections if custom section not found
      const fallbackCount = 6;
      return {
        html: html`
          <div class="custom-collections-grid">
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/wl574evn_nb_14_i.webp?v=1755662809" alt="Shoes" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Shoes</h3></div>
                </div>
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/wl574evg_nb_15_i.webp?v=1755663667" alt="Boots" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Boots</h3></div>
                </div>
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/wl574evn_nb_15_i.webp?v=1755662809" alt="Sneakers" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Sneakers</h3></div>
                </div>
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/ml574evg_wide-fit-shoes-new-balance.webp?v=1755454858" alt="Sandals" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Sandals</h3></div>
                </div>
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/wl574evn_nb_14_i.webp?v=1755662809" alt="Top" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Top</h3></div>
                </div>
                <div class="collection-card">
                  <div class="collection-image-container">
                    <img src="https://cdn.shopify.com/s/files/1/0279/3642/3981/files/wl574evg_nb_15_i.webp?v=1755663667" alt="Boots" class="collection-image" />
                  </div>
                  <div class="collection-content"><h3 class="collection-title">Boots</h3></div>
                </div>
              </div>
        `,
        count: fallbackCount
      };
    } catch (error) {
      console.warn('[Algolia Hooks] Error getting dynamic collections:', error);
      // Return empty div as fallback
      return {
        html: html`<div class="custom-collections-grid"></div>`,
        count: 0
      };
    }
  }
// Removed skeleton loading - using pagination instead
if (document.querySelector('#algolia-shopify-instantsearch')) {
  document.querySelector('#algolia-shopify-instantsearch').style.opacity = '1';
}

  // Global references for drawer functions
  let openDrawerGlobal = null;
  let closeDrawerGlobal = null;
  
  // Track if filter button has been clicked for the first time
  let isFirstFilterClick = true;

  // Function to create filter drawer
  function createFilterDrawer() {
    const el = document.getElementById("algolia-shopify-instantsearch");
    if (!el) return;
    const target = el.closest('.shopify-section');
    if (!target) return;
    const drawerHTML = `
      <style>
               .algolia-filter-drawer {
                 position: fixed;
                 top: 0;
                 left: -100%;
                 width: 100%;
                 max-width: 400px;
                 height: 100vh;
                 background: white;
                 z-index: 9999;
                 transition: left 0.3s ease;
                 box-shadow: 2px 0 10px rgba(0,0,0,0.1);
                 overflow-y: auto;
               }

               .algolia-filter-drawer.open {
                 left: 0;
               }

        .algolia-filter-drawer-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          z-index: 9998;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease, visibility 0.3s ease;
        }

        .algolia-filter-drawer-overlay.open {
          opacity: 1;
          visibility: visible;
        }

        .algolia-filter-header {
          padding: 20px;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f9fafb;
        }

        .algolia-filter-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin: 0;
        }

        .algolia-filter-close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #6b7280;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .algolia-filter-close:hover {
          color: #374151;
        }

        .algolia-filter-content {
          padding: 20px;
        }

        .algolia-filter-button {
          color: black;
          border: none;
          padding: 12px 0px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          z-index: 1000;
          transition: background-color 0.2s ease;
          display: flex;
          align-items: center;    
        }


        .algolia-filter-button:active {
          transform: translateY(1px);
        }

               .ais-facets {
                 display: none !important;
               }

               body.algolia-drawer-open .ais-facets {
                 display: block !important;
                 position: fixed !important;
                 top: 72px !important;
                 left: 0 !important;
                 width: 100% !important;
                 max-width: 400px !important;
                 height: 92vh !important;
                 background: white !important;
                 z-index: 10000 !important;
                 overflow-y: auto !important;
                 padding: 20px !important;
                 box-shadow: -2px 0 10px rgba(0,0,0,0.1) !important;
                 transform: translateX(0) !important;
                 transition: transform 0.3s ease !important;
               }

               body.algolia-drawer-open .algolia-filter-content .ais-facets {
                 position: static !important;
                 width: 100% !important;
                 max-width: none !important;
                 height: auto !important;
                 background: transparent !important;
                 box-shadow: none !important;
                 padding: 0 !important;
                 overflow: visible !important;
                 transform: none !important;
               }

               .algolia-filter-content .ais-facets {
                 padding: 0;
                 margin: 0;
               }

               .algolia-filter-content .ais-facet-dropdown-wrapper {
                 margin-bottom: 20px;
                 border: 1px solid #e5e7eb;
                 border-radius: 8px;
                 overflow: hidden;
               }

               .algolia-filter-content .ais-facet-dropdown-header {
                 background: #f9fafb;
                 padding: 12px 16px;
                 border-bottom: 1px solid #e5e7eb;
                 cursor: pointer;
                 display: flex;
                 justify-content: space-between;
                 align-items: center;
               }

               .algolia-filter-content .ais-facet-dropdown-header:hover {
                 background: #f3f4f6;
               }

               .algolia-filter-content .ais-facet-dropdown-content {
                 padding: 16px;
                 max-height: 200px;
                 overflow-y: auto;
               }

               .algolia-filter-content .ais-RefinementList-item {
                 margin-bottom: 8px;
               }

               .algolia-filter-content .ais-RefinementList-label {
                 display: flex;
                 align-items: center;
                 cursor: pointer;
                 padding: 8px 0;
                 border-radius: 4px;
                 transition: background-color 0.2s ease;
               }

               .algolia-filter-content .ais-RefinementList-label:hover {
                 background: #f3f4f6;
               }

               .algolia-filter-content .ais-RefinementList-checkbox {
                 margin-right: 8px;
               }

               .algolia-filter-content .ais-RefinementList-count {
                 margin-left: auto;
                 color: #6b7280;
                 font-size: 12px;
               }

               .algolia-filter-content .ais-RangeSlider {
                 padding: 16px;
               }

               .algolia-filter-content .ais-RangeSlider-track {
                 height: 4px;
                 background: #e5e7eb;
                 border-radius: 2px;
                 position: relative;
               }

               .algolia-filter-content .ais-RangeSlider-handle {
                 width: 20px;
                 height: 20px;
                 background: #3b82f6;
                 border: 2px solid white;
                 border-radius: 50%;
                 cursor: pointer;
                 box-shadow: 0 2px 4px rgba(0,0,0,0.1);
               }

               .algolia-filter-content .ais-RangeSlider-handle:hover {
                 background: #2563eb;
               }

               .available-widths .widths-container .widths-list {
                display: flex;
                gap: 5px;
               }
              .available-widths .widths-container .widths-list span.width-badge{
                padding: 3px;
                border: 2px solid #d1d5db;
                background: #fff;
                border-radius: 6px;
                font-size: 14px;
                font-weight: 500;
                color: #374151;
              }
               @media (max-width: 768px) {
                 .algolia-filter-drawer {
                   max-width: 100%;
                 }
               }
      </style>

      <button class="algolia-filter-button" id="algoliaFilterButton">
        All Filters
        <svg style="width: 10px;height: auto;margin-left: 8px;margin-top: 3px;" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="9.19238" width="1" height="7" transform="rotate(45 9.19238 0)" fill="currentColor"></rect>
        <rect x="0.707031" width="7" height="1" transform="rotate(45 0.707031 0)" fill="currentColor"></rect>
        </svg>
      </button>

      <div class="algolia-filter-drawer-overlay" id="algoliaFilterOverlay"></div>
      
      <div class="algolia-filter-drawer" id="algoliaFilterDrawer">
        <div class="algolia-filter-header">
          <h3 class="algolia-filter-title">Filter Products</h3>
          <button class="algolia-filter-close" id="algoliaFilterClose">×</button>
        </div>
        <div class="algolia-filter-content" id="algoliaFilterContent">
          <!-- Facets will be moved here -->
        </div>
      </div>
    `;

    target.insertAdjacentHTML('beforeend', drawerHTML);


    // Move filter button to sticky header
    function moveFilterButtonToStickyHeader() {
      const searchHeader = document.querySelector('.ais-search-header');
      const filterButton = document.getElementById('algoliaFilterButton');
      
      if (searchHeader && filterButton) {
        // Move filter button to the beginning of search header
        searchHeader.insertBefore(filterButton, searchHeader.firstChild);
      } else {
        setTimeout(moveFilterButtonToStickyHeader, 500);
      }
    }

    // Wait for elements to be available
    setTimeout(moveFilterButtonToStickyHeader, 1500);

    // Add event listeners
    const filterButton = document.getElementById('algoliaFilterButton');
    const filterOverlay = document.getElementById('algoliaFilterOverlay');
    const filterDrawer = document.getElementById('algoliaFilterDrawer');
    const filterClose = document.getElementById('algoliaFilterClose');

    function openDrawer() {
      // Add CSS class to show facets in drawer
      document.body.classList.add('algolia-drawer-open');
      filterDrawer.classList.add('open');
      filterOverlay.classList.add('open');
      
      // Fix for iOS Safari - use position fixed on body
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // Store scroll position for restoration
      document.body.setAttribute('data-scroll-y', scrollY);
      
      // Hide cookie consent and launcher elements
      const cookieWrapper = document.querySelector('.cky-btn-revisit-wrapper');
      const launcher = document.querySelector('#launcher');
      if (cookieWrapper) {
        cookieWrapper.style.display = 'none';
      }
      if (launcher) {
        launcher.style.display = 'none';
      }
      
    }

    function closeDrawer() {
      // Remove CSS class to hide facets
      document.body.classList.remove('algolia-drawer-open');
      filterDrawer.classList.remove('open');
      filterOverlay.classList.remove('open');
      
      // Fix for iOS Safari - restore scroll position
      const scrollY = document.body.getAttribute('data-scroll-y');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      
      // Restore scroll position
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY));
        document.body.removeAttribute('data-scroll-y');
      }
      
      // Show cookie consent and launcher elements
      const cookieWrapper = document.querySelector('.cky-btn-revisit-wrapper');
      const launcher = document.querySelector('#launcher');
      if (cookieWrapper) {
        cookieWrapper.style.display = 'flex';
      }
      if (launcher) {
        launcher.style.display = 'block';
      }
      
    }

    // Make functions globally accessible
    openDrawerGlobal = openDrawer;
    closeDrawerGlobal = closeDrawer;

    filterButton.addEventListener('click', function() {
      // Run the script on first filter button click
      if (isFirstFilterClick) {
          closeRangeSliderAccordions();
        isFirstFilterClick = false;
      }
      openDrawer();
    });
    filterClose.addEventListener('click', closeDrawer);
    filterOverlay.addEventListener('click', closeDrawer);

    // Close drawer on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterDrawer.classList.contains('open')) {
        closeDrawer();
      }
    });

  }

  // Call the filter drawer function
  createFilterDrawer();

  // Desktop filter bar: pin with position:fixed + placeholder (CSS sticky gaped on fast scroll)
  function makeSearchHeaderSticky() {
    if (window.innerWidth <= 768) return;

    const searchHeader = document.querySelector('.ais-search-header');
    if (!searchHeader) {
      setTimeout(makeSearchHeaderSticky, 300);
      return;
    }

    if (searchHeader.dataset.filterStickyInit === '1') return;
    searchHeader.dataset.filterStickyInit = '1';

    let placeholder = document.querySelector('.ais-search-header-placeholder');
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'ais-search-header-placeholder';
      searchHeader.parentNode.insertBefore(placeholder, searchHeader);
    }

    let stuck = false;
    let ticking = false;
    let naturalTop = 0;

    function measureNaturalTop() {
      if (stuck) {
        naturalTop = placeholder.getBoundingClientRect().top + window.pageYOffset;
      } else {
        naturalTop = searchHeader.getBoundingClientRect().top + window.pageYOffset;
      }
    }

    function getHeaderOffset() {
      const header = document.querySelector('.site-header');
      if (!header) return 0;

      const rect = header.getBoundingClientRect();

      // Fixed sticky header: pin filter directly under it
      if (header.classList.contains('site-header--stuck')) {
        if (
          !header.classList.contains('site-header--opening') &&
          !document.body.classList.contains('template-collection') &&
          !document.body.classList.contains('template-search')
        ) {
          return 0;
        }
        return Math.max(0, Math.round(rect.bottom));
      }

      // In-flow header still intersecting the top of the viewport
      if (rect.top <= 0 && rect.bottom > 0) {
        return Math.round(rect.bottom);
      }

      // Header fully below or fully above — no reserved gap
      return 0;
    }

    function stick(headerOffset) {
      const height = searchHeader.offsetHeight;
      placeholder.style.height = height + 'px';
      placeholder.classList.add('is-active');
      searchHeader.classList.add('is-filter-stuck');
      searchHeader.style.setProperty('top', headerOffset + 'px', 'important');
      stuck = true;
    }

    function unstick() {
      placeholder.classList.remove('is-active');
      placeholder.style.height = '';
      searchHeader.classList.remove('is-filter-stuck');
      searchHeader.style.removeProperty('top');
      stuck = false;
    }

    function update() {
      if (window.innerWidth <= 768) {
        if (stuck) unstick();
        ticking = false;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerOffset = getHeaderOffset();

      if (!stuck) {
        measureNaturalTop();
      }

      // Pin once the bar would scroll above the header bottom
      if (scrollTop + headerOffset >= naturalTop) {
        if (!stuck) {
          stick(headerOffset);
        } else {
          searchHeader.style.setProperty('top', headerOffset + 'px', 'important');
        }
      } else if (stuck) {
        unstick();
      }

      ticking = false;
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    measureNaturalTop();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      if (stuck) unstick();
      measureNaturalTop();
      requestUpdate();
    });

    const header = document.querySelector('.site-header');
    if (header) {
      const observer = new MutationObserver(requestUpdate);
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    requestUpdate();
  }

  makeSearchHeaderSticky();

  // Quick Filters for Desktop - Opens drawer with specific filter expanded
  function createQuickFilters() {
    if (window.innerWidth < 1100) return;
  
    setTimeout(() => {
      const searchHeader = document.querySelector('.ais-search-header');
      const filterButton = searchHeader?.querySelector('.algolia-filter-button');
      if (!searchHeader || !filterButton || document.querySelector('.quick-filters-container')) return;
  
      // Get first 2 valid filters (ignore "Selected filters")
      const allFilters = [...document.querySelectorAll('.ais-facet--header')]
        .filter(h => !h.classList.contains('ais-current-refined-values--header'));
      const topFilters = allFilters.slice(0, 4);
  
      if (!topFilters.length) {
        console.warn('[Quick Filters] No filters found, retrying...');
        return setTimeout(createQuickFilters, 1000);
      }
  
      // Generate buttons
      const quickFiltersHTML = `
        <div class="quick-filters-container">
          ${topFilters.map(header => {
            const text = header.textContent.trim();
            return `
              <button class="quick-filter-btn" data-filter-text="${text}">
                ${text}
                <span class="quick-filter-arrow">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="9.192" width="1" height="7" transform="rotate(45 9.192 0)" fill="currentColor"></rect>
                    <rect x="0.707" width="7" height="1" transform="rotate(45 0.707 0)" fill="currentColor"></rect>
                  </svg>
                </span>
              </button>`;
          }).join('')}
        </div>`;
      filterButton.insertAdjacentHTML('afterend', quickFiltersHTML);
  
      // Quick filter click events
      document.querySelectorAll('.quick-filter-btn').forEach(btn =>
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
  
          const targetText = btn.dataset.filterText;
          if (typeof openDrawerGlobal !== 'function') {
            console.warn('[Quick Filters] Drawer not ready');
            return;
          }
  
          openDrawerGlobal();
  
          setTimeout(() => {
            const facets = [...document.querySelectorAll('.ais-facet--header')]
              .filter(h => !h.classList.contains('ais-current-refined-values--header'));
            const target = facets.find(h => h.textContent.trim() === targetText);
            if (!target) return console.warn('[Quick Filters] Filter not found:', targetText);
  
            // Close all except target
            facets.forEach(h => {
              if (h !== target && !h.classList.contains('open')) h.click();
            });
  
            // Open target (since .open = closed)
            setTimeout(() => {
              if (target.classList.contains('open')) target.click();
            }, 100);
          }, 300);
        })
      );
    }, 2000);
  }
  
  createQuickFilters();

  const SEARCH_DEBOUNCE_MS = 800;
  const MIN_SEARCH_QUERY_LENGTH = 3;

  function shouldRunAlgoliaSearch(query) {
    return String(query || "").trim().length >= MIN_SEARCH_QUERY_LENGTH;
  }

  function debouncePromise(fn, delayMs) {
    let timerId;
    return function debounced(...args) {
      if (timerId) clearTimeout(timerId);
      return new Promise((resolve, reject) => {
        timerId = setTimeout(() => {
          timerId = undefined;
          Promise.resolve(fn(...args)).then(resolve).catch(reject);
        }, delayMs);
      });
    };
  }
  
  function registerAlgoliaHooks() {
    if (hooksRegistered) return;
    if (!window.algoliaShopify || !window.algoliaShopify.hooks) return;

    try {
      algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
        const { configure } = window.algoliaShopify.externals.widgets;
        configureWidget = configure({
          facetingAfterDistinct: false,
        });
        return [configureWidget];
      });
      algoliaShopify.hooks.registerHook(
        "beforeAutocompleteConfigurationOptions",
        function (config, context) {
          const query = String(
            context?.query ?? config?.queries?.[0]?.query ?? ""
          ).trim();

          if (!shouldRunAlgoliaSearch(query)) {
            config.queries = (config.queries || []).map((q) => ({
              ...q,
              params: {
                ...(q.params || {}),
                hitsPerPage: 0,
                analytics: false,
              },
            }));
          }
          return config;
        }
      );

      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchConfigurationOptions",
        function (options) {
          options.stalledSearchDelay = SEARCH_DEBOUNCE_MS + 300;
          const previousSearchFunction = options.searchFunction;
          options.searchFunction = function (helper) {
            const query = String(helper.state.query || "").trim();
            if (query.length > 0 && query.length < MIN_SEARCH_QUERY_LENGTH) {
              return;
            }
            if (typeof previousSearchFunction === "function") {
              previousSearchFunction(helper);
            } else {
              helper.search();
            }
          };
          // Restore filters before InstantSearch reads the URL (refresh drops them).
          appendStoredAlgoliaFiltersToUrl();

          // Keep refinements when facet widgets remount (filter drawer).
          options.future = {
            ...(options.future || {}),
            preserveSharedStateOnUnmount: true,
          };

          // Prefer patching Shopify's router; fall back to a history router that
          // reuses existing createURL/parseURL so refresh still hydrates filters.
          const historyFactory =
            window.algoliaShopify?.externals?.routers?.history ||
            window.instantsearch?.routers?.history;
          if (typeof historyFactory === "function") {
            const existingRouting =
              options.routing && typeof options.routing === "object"
                ? options.routing
                : {};
            const existingRouter = existingRouting.router;
            const routerOptions = {
              cleanUrlOnDispose: false,
            };
            if (existingRouter && typeof existingRouter.createURL === "function") {
              routerOptions.createURL = existingRouter.createURL.bind(existingRouter);
            }
            if (existingRouter && typeof existingRouter.parseURL === "function") {
              routerOptions.parseURL = existingRouter.parseURL.bind(existingRouter);
            }
            options.routing = {
              ...existingRouting,
              ...(existingRouting.stateMapping
                ? { stateMapping: existingRouting.stateMapping }
                : {}),
              router: historyFactory(routerOptions),
            };
          }
          return options;
        }
      );

      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchAllowParamsArray",
        function () {
          return [...arguments, "ref", "utm_source"];
        }
      );

      // ===== Autocomplete Options Hook =====
      algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
        options.placeholder = "Search Our Products";
        options.openOnFocus = true;
        options.panelPlacement = "full-width";
        options.stallThreshold = SEARCH_DEBOUNCE_MS + 300;
        //  Ensure plugins array exists
        if (!options.plugins) options.plugins = [];
        //  Add Recent Searches Plugin
        const recent =
          window["@algolia/autocomplete-plugin-recent-searches"]?.createLocalStorageRecentSearchesPlugin({
            key: "shopifyRecentSearches",
            limit: 5,
          });

        if (recent){
          options.plugins.push(recent);
        }
        else{
          console.warn("[DEBUG] Recent searches plugin not loaded ");
        }

        // Add custom collections count plugin using official Algolia approach
        const { searchClient } = window.algoliaShopify;
        const { getAlgoliaResults } = window.algoliaShopify.externals;

        const fetchCollectionsCount = debouncePromise(function (activeQuery, setContext) {
          if (!shouldRunAlgoliaSearch(activeQuery)) {
            setContext({ nbCollections: 0 });
            return Promise.resolve([]);
          }
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: window.algoliaShopify.config.index_prefix + "collections",
                query: activeQuery,
              },
            ],
            transformResponse({ results }) {
              setContext({
                nbCollections: results[0]?.nbHits || 0,
              });
              return [];
            },
          });
        }, SEARCH_DEBOUNCE_MS);

        const collectionsCountPlugin = {
          name: "collections-count-plugin",
          getSources({ query, setContext }) {
            return [
              {
                sourceId: "collectionsCount",
                getItems() {
                  return fetchCollectionsCount(query, setContext);
                },
                templates: {
                  item() { return ''; }
                },
              },
            ];
          },
        };

        options.plugins.push(collectionsCountPlugin);

        return options;
      });

      // ===== Product Template Hook =====
      algoliaShopify.hooks.registerHook(
        "beforeAutocompleteProductTemplate",
        function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
          const { html, item, components } = templateOptions;
          const originalImageAlt = getOriginalImageAltFromItem(item);
          const titleOnlyFallback =
            (typeof item?.title === "string" && item.title.trim()) ||
            (typeof item?.name === "string" && item.name.trim()) ||
            "Product";
          const itemAltTagFlag = parseBoolLike(
            item?.meta?.custom?.product_image_alt_tags ??
              item?.custom?.product_image_alt_tags ??
              item?.metafields?.custom?.product_image_alt_tags ??
              item?.product_image_alt_tags
          );
          const imageAlt = itemAltTagFlag
            ? (originalImageAlt || titleOnlyFallback)
            : buildAlgoliaImageAlt(item);
          return html`
            <a
              href="${itemLink}"
              class="ais-product ais-ProductItem aa-ItemLink product-card search-page-card"
              data-product-handle="${item.handle}"
              data-product-id="${item.objectID}"
              data-variant-id="${item.variant_id || ''}"
              onClick="${() => trackSearchAttribution(item)}"
            >
              <div class="aa-ItemContent">
                <!--  Product Image + Quick Buy Desktop -->
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                         <img src="${item.image}" alt="${imageAlt}" />

                  <div class="ais-ProductItem_QuickBuyContainer" data-product-handle="${item.handle}">
                    <div
                      class="ais-ProductItem_DesktopQuickBuy"
                      data-algolia-autocomplete-card-el="desktop-quick-buy-placement"
                      aria-hidden="true"
                      aria-busy="false"
                    ></div>
                  </div>
                </div>
                

                <div class="aa-ItemContentBody">
                  <!--  Brand / Strapline + Mobile Quick Buy -->
                  <div class="aa-ItemContentHeader">
                    <div class="aa-ItemContentStrapline">${item.vendor || ""}</div>
                    <button
                      type="button"
                      data-product-handle="${item.handle}"
                      class="aa-ItemContentQuickbuyMobile"
                    >
                      <span class="hd-Banner_Icon">
                        <svg
                          id="baoIconBag"
                          viewBox="0 0 18 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1 19H16.75L15.711 6.53157C15.6624 5.9485 15.175 5.5 14.5899 5.5H3.16015C2.57505 5.5 2.08763 5.9485 2.03904 6.53157L1 19Z"
                            stroke="currentColor"
                          ></path>
                          <path
                            fill="transparent"
                            d="M12 7C12 6.24543 12 4.43578 12 2.99988C12 1.89531 11.1046 1 10 1H8.00002C6.89545 1 6.00002 1.89543 6.00002 3V7"
                            stroke="currentColor"
                            stroke-linecap="square"
                          ></path>
                        </svg>
                         <!-- Eye Icon -->
                          <svg
                            id="baoIconEye"
                            class="icon-eye"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <path
                              d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7z"
                              stroke="currentColor"
                              stroke-width="2"
                              fill="none"
                            />
                            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
                          </svg>
                      </span>
                    </button>
                  </div>

                  <!--  Title -->
                  <div class="aa-ItemContentTitleWrapper">
                    <div class="aa-ItemContentTitle">
                      ${components.Highlight({ hit: item, attribute: "title" })}
                      <span class="algolia-variant">
                        ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                      </span>
                    </div>
                  </div>

                  <!--  Price -->
                  <div class="aa-ItemContentPrice">
                    <div class="aa-ItemContentPriceCurrent price">
                      ${(() => {
                        const priceHtml = algoliaShopify.helpers.displayPrice(item, distinct);
                        // Clean HTML tags and convert Rs. to £
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = priceHtml;
                        const textContent = tempDiv.textContent || tempDiv.innerText || '';
                        return textContent.replace(/Rs\./g, "£").replace(/£\s*([0-9,.]+)\s*-\s*£\s*([0-9,.]+)/g, "From £$1").trim();
                      })()}
                    </div>
                  </div>
  <!-- Available Widths -->
                  <div class="available-widths" data-product-handle="${item.handle}">
                    ${(() => {
                      try {
                        const widths = getAvailableWidthsForProduct(item.handle, false);
                        return generateWidthsHTML(widths);
                      } catch (e) {
                        return '';
                      }
                    })()}
                  </div>
                  <!--  Trustpilot Star Rating -->
                  <div class="trustpilot-product-rating" data-trustpilot-product="${item.objectID}">
                    <div class="trustpilot-widget" 
                         data-locale="en-US" 
                         data-template-id="5406e65db0d04a09e042d5fc" 
                         data-businessunit-id="5bf3cd76608c550001c8463c" 
                         data-style-height="28px" 
                         data-style-width="100%" 
                         data-token="2322de43-cadc-44c9-af2d-aa7a6619cb2d">
                      <a href="https://www.trustpilot.com/review/www.widefitshoes.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );

      // ===== Main Template Hook =====
      algoliaShopify.hooks.registerHook(
        "beforeAutocompleteMainTemplate",
        function (_defaultTemplate, { html, state }, elements, displaySuggestions) {
          const query = state.query || "";
          const hasQuery = query.trim().length > 0;

        // Try to count current query suggestions items (best-effort)
        const qs_count = (() => {
          try {
            // Default autocomplete id is 0; also try a generic selector as fallback
            const list = document.getElementById('autocomplete-0-querySuggestionsPlugin-list')
              || document.querySelector('.aa-Panel .aa-Source[data-autocomplete-source-id*="querySuggestions"] .aa-List')
              || document.querySelector('.aa-Panel .aa-Source[data-source-id*="querySuggestions"] .aa-List');
            return list ? list.childElementCount : 0;
          } catch (e) {
            return 0;
          }
        })();

        // Get total products count from state.context
        const total_products_count = state.context?.nbProducts || 0;

          // Static pages
          const staticPages = [
            { label: "About", url: "/pages/about" },
            { label: "Contact", url: "/pages/contact" },
            { label: "Blog", url: "/blog" },
            { label: "FAQ", url: "/pages/faq" },
            // { label: "Terms of Service", url: "/pages/terms-of-service" },
            { label: "Refunds & Exchanges", url: "/pages/refunds-and-exchanges" },
          ];

         

          // Dynamic collections from custom section
          const collectionsData = getDynamicCollections(html);
          const staticCollections = collectionsData.html;
          const staticCollectionsCount = collectionsData.count;

          // Device check
          const isMobile =
            typeof window !== "undefined" &&
            ((window.matchMedia && window.matchMedia("(max-width: 768px)").matches) ||
              /mobi|android|iphone|ipad|ipod/i.test(navigator.userAgent));

          // ===== Empty input (focus) =====
          if (!hasQuery) {
            return html`
              <div class="aa-PanelLayout aa-Panel--scrollable ${isMobile ? "aa-Panel--mobile" : ""}">
                <div class="aa-PanelSections">
                  <div class="aa-PanelSection--fullblock">
                    <div class="aa-PanelSection--left">
                      ${elements.recentSearchesPlugin &&
                        html`
                          <div class="aa-PanelSection--left-top">
                            <div class="aa-SourceHeader">
                              <span class="aa-SourceHeaderTitle">Recent Searches</span>
                              <div class="aa-SourceHeaderLine"></div>
                            </div>
                            ${elements.recentSearchesPlugin}
                          </div>
                        `}
                      ${displaySuggestions &&
                        html`
                          <div class="aa-PanelSection--left-top">
                            <div class="aa-SourceHeader">
                              <span class="aa-SourceHeaderTitle">Popular Searches ${qs_count ? `(${qs_count})` : ''}</span>
                              <div class="aa-SourceHeaderLine"></div>
                            </div>
                            ${elements.querySuggestionsPlugin}
                          </div>
                        `}
                      <div class="aa-Sourcediv">
                        <div class="aa-SourceHeader">
                          <span class="aa-SourceHeaderTitle">Pages (${staticPages.length})</span>
                          <div class="aa-SourceHeaderLine"></div>
                        </div>
                        <ul class="aa-List">
                          ${staticPages.slice(0, 5).map(
                            (l) => html`
                              <li class="aa-Item">
                                <a class="aa-ItemLink" href="${l.url}">
                                  <div class="aa-ItemContent">
                                    <div class="aa-ItemContentBody">
                                      <div class="aa-ItemContentTitle">${l.label}</div>
                                    </div>
                                  </div>
                                </a>
                              </li>
                            `
                          )}
                        </ul>
                      </div>
                      
                      <!-- Close Button -->
                      <div class="aa-PanelSection--close">
                        <button class="aa-CloseButton" type="button" aria-label="Close search">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="aa-PanelSection--right">
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle">Popular Collections ${staticCollectionsCount ? `(${staticCollectionsCount})` : ''}</span>
                        <div class="aa-SourceHeaderLine"></div>
                      </div>
                      ${staticCollections}
                    </div>
                  </div>
                </div>
              </div>
            `;
          }

          // ===== Typing =====
          return html`
          <div class="aa-PanelLayout aa-Panel--scrollable typing-state ${isMobile ? "aa-Panel--mobile" : ""}">
            <div class="aa-PanelSections">
              ${(elements.querySuggestionsPlugin || elements.suggestions) && html`
              <div class="aa-PanelSection--left-top">
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">Suggestions ${qs_count ? `(${qs_count})` : ''}</span>
                  <div class="aa-SourceHeaderLine"></div>
                </div>
                ${elements.querySuggestionsPlugin || elements.suggestions || ""}
              </div>
              `}
        
              <div class="aa-PanelSection--fullblock">
                <div class="aa-PanelSection--left">
                  <div class="aa-Sourcediv">
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">Pages (${staticPages.length})</span>
                      <div class="aa-SourceHeaderLine"></div>
                    </div>
                    <ul class="aa-List">
                      ${staticPages.slice(0, 5).map(
                        (l) => html`
                          <li class="aa-Item">
                            <a class="aa-ItemLink" href="${l.url}">
                              <div class="aa-ItemContent">
                                <div class="aa-ItemContentBody">
                                  <div class="aa-ItemContentTitle">${l.label}</div>
                                </div>
                              </div>
                            </a>
                          </li>
                        `
                      )}
                    </ul>
                  </div>
                 
                  ${(elements.collections || elements.collectionsPlugin) && html`
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">Collections ${state.context?.nbCollections ? `(${state.context.nbCollections})` : ''}</span>
                      <div class="aa-SourceHeaderLine"></div>
                    </div>
                  `}
                  ${elements.collections || elements.collectionsPlugin || ""}
        
                  <!-- Close Button -->
                  <div class="aa-PanelSection--close">
                    <button class="aa-CloseButton" type="button" aria-label="Close search">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
        
                <div class="aa-PanelSection--right">
                  <div class="aa-SourceHeader aa-SourceHeader--products">
                    <span class="aa-SourceHeaderTitle">Products for "${query}" ${total_products_count ? `(${total_products_count})` : ''}</span>
                    <a 
                      href="/search?q=${encodeURIComponent(query)}" 
                      class="aa-ViewAllResults"
                    >
                      View all
                    </a>
                  </div>
                  ${elements.products || elements.productsPlugin || ""}
                </div>
              </div>
            </div>
          </div>
        `;
        
        }
      );

      algoliaShopify.hooks.registerHook(
          "beforeInstantSearchFacetParamsOptions",
          (params, facet) => {
            if (facet.name === "options.size" || facet.name === "options.width") {
              return {
                ...params,
                sortBy: ["name:asc"],
                transformItems(items) {
                  return items.sort((a, b) => {
                    const numA = parseFloat(a.value);
                    const numB = parseFloat(b.value);
                    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                    if (!isNaN(numA)) return -1;
                    if (!isNaN(numB)) return 1;
                    return a.value.localeCompare(b.value);
                  });
                },
              };
            }
            return { ...params };
          }
        );

      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchProductTemplate",
        function (allWidgetConfiguration, algoliaBundle) {
          let show_alt_tag = algoliaBundle?.meta?.custom?.product_image_alt_tags;

          const p_title = (algoliaBundle?.title || "").trim();
          const normalize = (value) =>
            typeof value === "string" ? value.trim() : "";
          const pickFirstNonEmpty = (values) => {
            for (const value of values) {
              const normalized = normalize(value);
              if (normalized) return normalized;
            }
            return "";
          };

          let p_color = pickFirstNonEmpty([
            algoliaBundle?.options?.colour,
            algoliaBundle?.options?.color,
            algoliaBundle?.options?.Colour,
            algoliaBundle?.options?.Color,
            algoliaBundle?.option1,
            algoliaBundle?.variant_option_1,
            algoliaBundle?.color,
            algoliaBundle?.colour,
          ]);

          if (!p_color && algoliaBundle?.options) {
            const options = algoliaBundle.options;

            if (Array.isArray(options)) {
              const optionString = options.find(
                (opt) => typeof opt === "string" && opt.trim()
              );
              if (optionString) p_color = optionString.trim();

              if (!p_color) {
                const colorOptionObj = options.find((opt) => {
                  const optionName = normalize(opt?.name || opt?.label || "");
                  return /colou?r/i.test(optionName);
                });
                if (colorOptionObj) {
                  p_color = pickFirstNonEmpty([
                    colorOptionObj.value,
                    Array.isArray(colorOptionObj.values)
                      ? colorOptionObj.values[0]
                      : "",
                  ]);
                }
              }
            } else if (typeof options === "object") {
              const colorKey = Object.keys(options).find((key) =>
                /colou?r/i.test(key)
              );
              if (colorKey) {
                const colorValue = options[colorKey];
                p_color = pickFirstNonEmpty([
                  colorValue,
                  Array.isArray(colorValue) ? colorValue[0] : "",
                ]);
              }
            }
          }

          if (!p_color && Array.isArray(algoliaBundle?.named_tags)) {
            const colorTag = algoliaBundle.named_tags.find((tag) =>
              /colou?r[:_\-\s]/i.test(tag)
            );
            if (colorTag) {
              p_color = normalize(
                colorTag.replace(/.*colou?r[:_\-\s]+/i, "").trim()
              );
            }
          }

          if (!p_color) {
            const variantTitle = (algoliaBundle?.variant_title || "").trim();
            if (variantTitle && variantTitle.toLowerCase() !== "default title") {
              const firstPart = variantTitle.split("/")[0].trim();
              p_color = firstPart.split("(")[0].trim();
            }
          }

          if (!p_color) {
            const titlePart = p_title.split(" - ")[1] || "";
            if (titlePart) {
              p_color = titlePart.split("(")[0].trim();
            }
          }

          if (!p_color) {
            const colorKeywords = [
              "rose gold", "navy blue", "light blue", "dark blue", "off white",
              "charcoal", "burgundy", "purple", "yellow", "orange", "silver",
              "gold", "brown", "green", "white", "black", "beige", "cream",
              "khaki", "olive", "pink", "grey", "gray", "blue", "red", "tan", "navy",
            ];
            const loweredTitle = p_title.toLowerCase();
            const matchedColor = colorKeywords.find((color) =>
              new RegExp(`\\b${color.replace(/\s+/g, "\\s+")}\\b`, "i").test(loweredTitle)
            );
            if (matchedColor) {
              p_color = matchedColor
                .split(" ")
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join(" ");
            }
          }

          allWidgetConfiguration.props["data-product-image-alt"] =
            `${p_title} in ${p_color} - Image 1`;
          allWidgetConfiguration.props["data-product-color"] = p_color;
          const useTitleOnlyAlt = parseBoolLike(show_alt_tag);
          allWidgetConfiguration.props["data-product-image-alt-tags"] =
            useTitleOnlyAlt ? "true" : "false";
          if (useTitleOnlyAlt) {
            allWidgetConfiguration.props["data-product-image-alt"] =
              getOriginalImageAltFromItem(algoliaBundle) || p_title;
          }
          return allWidgetConfiguration;
        }
      );

      hooksRegistered = true;
    } catch (e) {
      console.warn("[Algolia Hooks] Failed to register hooks", e);
    }
  }

  // Transform search page to use aa-ItemContent structure
  function transformSearchPageCards() {
    if (
      window.location.pathname === '/search' ||
      window.location.pathname.includes('/search') ||
      window.location.pathname.includes('/collections/')
    ) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            const hitsItems = document.querySelectorAll('.ais-Hits-item');
            hitsItems.forEach(function(item) {
              if (!item.classList.contains('transformed')) {
                transformCard(item);
                markTransformedIfAlreadyBuilt(item);
              }
            });
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Transform existing cards immediately
      setTimeout(() => {
        const hitsItems = document.querySelectorAll('.ais-Hits-item');
        hitsItems.forEach(function(item){
          transformCard(item);
          markTransformedIfAlreadyBuilt(item);
        });
      }, 1000);
    }
  }

  function transformCard(item) {
    if (item.classList.contains('transformed')) return;
    
    const hit = item.querySelector('.ais-hit');
    if (!hit) return;
    
    const image = hit.querySelector('.ais-hit--picture');
    const details = hit.querySelector('.ais-hit--details');
    const title = hit.querySelector('.ais-hit--title a');
    const subtitle = hit.querySelector('.ais-hit--subtitle');
    const price = hit.querySelector('.ais-hit--price b');
    console.log("hits-----------=============",hit)
    if (!image || !details || !title || !price) return;
    
    // Get product data from existing elements
    const productHandle = hit.getAttribute('data-handle');
    const productId = hit.getAttribute('data-algolia-objectid');
    const productTitle = title.textContent.trim();
    const productVendor = subtitle ? subtitle.textContent.split(' by ')[1] || '' : '';
    const productPrice = price.textContent;
    const productImage = image.src;
    const productImageAlt =
      hit.getAttribute('data-product-image-alt') ||
      item.getAttribute('data-product-image-alt') ||
      '';
    const defaultImageAlt = (image.alt || '').trim();
    const altTagsAttr =
      hit.getAttribute('data-product-image-alt-tags') ||
      item.getAttribute('data-product-image-alt-tags') ||
      '';

    let parsedHitData = null;
    try {
      const hitDataStr = hit.getAttribute('data-hit');
      if (hitDataStr) parsedHitData = JSON.parse(hitDataStr);
    } catch (_) {
      parsedHitData = null;
    }

    const customColor =
      hit.getAttribute('data-product-color') ||
      hit.getAttribute('data-color') ||
      parsedHitData?.options?.colour ||
      parsedHitData?.options?.color ||
      parsedHitData?.option1 ||
      parsedHitData?.variant_option_1 ||
      parsedHitData?.color ||
      parsedHitData?.colour ||
      '';

    const customGeneratedAlt = buildAlgoliaImageAlt({
      title: productTitle,
      color: customColor,
      colour: customColor,
      variant_title:
        parsedHitData?.variant_title || hit.getAttribute('data-variant-title'),
    });

    const productImageAltTrim = (productImageAlt || '').trim();
    const inferredFlagFromHit = parseBoolLike(
      parsedHitData?.meta?.custom?.product_image_alt_tags ??
        parsedHitData?.custom?.product_image_alt_tags ??
        parsedHitData?.metafields?.custom?.product_image_alt_tags ??
        parsedHitData?.product_image_alt_tags
    );
    const useTitleOnlyAlt =
      altTagsAttr !== '' ? parseBoolLike(altTagsAttr) : inferredFlagFromHit;

    const finalTransformCardAlt = useTitleOnlyAlt
      ? (productImageAltTrim || defaultImageAlt || productTitle)
      : customGeneratedAlt || productImageAltTrim || defaultImageAlt;

     // Try to get compare_at_price from data attributes, hidden elements, or Algolia hit data
    let compareAtPrice = null;
    try {
      // Method 1: Check if compare_at_price is in data attributes
      const comparePriceAttr = hit.getAttribute('data-compare-at-price');
      if (comparePriceAttr) {
        compareAtPrice = parseFloat(comparePriceAttr);
      }

      // Method 2: Try to find a compare price element in DOM
      if (!compareAtPrice) {
        const comparePriceEl = hit.querySelector('.ais-hit--compare-price, .compare-at-price, [data-compare-at-price]');
        if (comparePriceEl) {
          const compareText = comparePriceEl.textContent || comparePriceEl.getAttribute('data-compare-at-price');
          compareAtPrice = parseFloat(compareText.replace(/[£$,]/g, ''));
        }
      }

      // Method 3: Try to get from Algolia hit data if available (via window.algoliaShopify or hit dataset)
      if (!compareAtPrice && productId) {
        // Check if hit object is stored in dataset
        const hitDataStr = hit.getAttribute('data-hit');
        if (hitDataStr) {
          try {
            const hitData = JSON.parse(hitDataStr);
            if (hitData.compare_at_price) {
              compareAtPrice = parseFloat(hitData.compare_at_price);
            }
          } catch(e) {}
        }

        // Try to find in global Algolia hits data
        if (!compareAtPrice && window.algoliaShopify && window.algoliaShopify.instantsearch) {
          const search = window.algoliaShopify.instantsearch.search;
          if (search && search.helper && search.helper.lastResults) {
            const hits = search.helper.lastResults.hits || [];
            const matchedHit = hits.find(h => h.objectID === productId);
            if (matchedHit && matchedHit.compare_at_price) {
              compareAtPrice = parseFloat(matchedHit.compare_at_price);
            }
          }
        }
      }
    } catch(e) {
      console.warn('Error getting compare_at_price:', e);
    }


    // Create new structure matching autocomplete exactly
    const newCard = document.createElement('a');
    newCard.href = `/products/${productHandle}`;
    newCard.className = 'ais-product ais-ProductItem aa-ItemLink product-card search-page-card';
    newCard.setAttribute('data-product-handle', productHandle);
    newCard.setAttribute('data-product-id', productId);
    newCard.setAttribute('data-variant-id', '');
    
    // Parse actual price from productPrice
    let actualPrice = null;
    try {
      // Extract numeric value from productPrice (remove currency symbols, commas, etc.)
      const priceMatch = productPrice.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        actualPrice = parseFloat(priceMatch[0].replace(/,/g, ''));
      }
    } catch(e) {
      console.warn('Error parsing actual price:', e);
    }
    
    // Show "Black Friday Sale" badge only if compareAtPrice is higher than actual price
    let saleBadgeText = '';
    const saleBadgeEnabled = !(window.theme && window.theme.settings && window.theme.settings.saleBadgeEnable === false);
    if (saleBadgeEnabled && compareAtPrice && actualPrice && compareAtPrice > actualPrice) {
      saleBadgeText = (window.theme && window.theme.settings && window.theme.settings.saleBadgeText) || 'Sale';
    }
    newCard.innerHTML = `
      <div class="aa-ItemContent">
       <!-- Sale Badge -->
      ${saleBadgeText ? `
      <div class="product-badge-corner">
        <div class="product-badge"><span class="badge-text">${saleBadgeText}</span></div>
      </div>` : ''}

        <!-- Product Image + Quick Buy Desktop -->
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img src="${productImage}" alt="${finalTransformCardAlt}" />
          <div class="ais-ProductItem_QuickBuyContainer" data-product-handle="${productHandle}">
            <div class="ais-ProductItem_DesktopQuickBuy" data-algolia-autocomplete-card-el="desktop-quick-buy-placement" aria-hidden="true" aria-busy="false"></div>
          </div>
        </div>
        
        <div class="aa-ItemContentBody">
          <!-- Brand / Strapline + Mobile Quick Buy -->
          <div class="aa-ItemContentHeader">
            <div class="aa-ItemContentStrapline">${productVendor}</div>
            <button type="button" data-product-handle="${productHandle}" class="prd-Card_QuickBuyTrigger aa-ItemContentQuickbuyMobile" data-algolia-autocomplete-card-el="mobile-trigger">
              <span class="hd-Banner_Icon">
                <svg id="baoIconBag" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 19H16.75L15.711 6.53157C15.6624 5.9485 15.175 5.5 14.5899 5.5H3.16015C2.57505 5.5 2.08763 5.9485 2.03904 6.53157L1 19Z" stroke="currentColor"></path>
                  <path fill="transparent" d="M12 7C12 6.24543 12 4.43578 12 2.99988C12 1.89531 11.1046 1 10 1H8.00002C6.89545 1 6.00002 1.89543 6.00002 3V7" stroke="currentColor" stroke-linecap="square"></path>
                </svg>
              </span>
            </button>
          </div>

          <!-- Title -->
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">${productTitle}<span class="algolia-variant"> </span></div>
          </div>

          <!-- Price -->
          <div class="aa-ItemContentPrice">
          ${compareAtPrice && actualPrice && compareAtPrice > actualPrice ? `
            <div class="aa-ItemContentPriceOriginal" style="text-decoration: line-through; color: #999; font-size: 0.9em; margin-bottom: 4px;">
              ${(() => {
                // Format compare_at_price as currency
                const formatted = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(compareAtPrice);
                return formatted;
              })()}
            </div>
            ` : ''}
            <div class="aa-ItemContentPriceCurrent price">
              ${(() => {
                // Clean HTML tags and convert Rs. to £
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = productPrice;
                const textContent = tempDiv.textContent || tempDiv.innerText || '';
                return textContent.replace(/Rs\./g, '£').replace(/£\s*([0-9,.]+)\s*-\s*£\s*([0-9,.]+)/g, "From £$1").trim();
              })()}
            </div>
          </div>

          <!-- Available Widths -->
          <div class="available-widths" data-product-handle="${productHandle}">
            ${generateWidthsHTML(getAvailableWidthsForProduct(productHandle, false))}
          </div>

          <!-- Trustpilot Star Rating -->
          <div class="trustpilot-product-rating" data-trustpilot-product="${productId}">
            <div class="trustpilot-widget" data-locale="en-US" data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="5bf3cd76608c550001c8463c" data-style-height="28px" data-style-width="100%" data-token="2322de43-cadc-44c9-af2d-aa7a6619cb2d">
              <a href="https://www.trustpilot.com/review/www.widefitshoes.co.uk" target="_blank" rel="noopener">Trustpilot</a>
            </div>
          </div>
        </div>
      </div>
    `;
    
    // Replace the old structure
    item.innerHTML = '';
    item.appendChild(newCard);
    item.classList.add('transformed');
   
    // Initialize Trustpilot for this card
    setTimeout(() => {
      if (window.Trustpilot && window.Trustpilot.loadFromElement) {
        const widget = newCard.querySelector('.trustpilot-widget');
        if (widget && !widget.hasAttribute('data-trustpilot-loaded')) {
          window.Trustpilot.loadFromElement(widget);
          widget.setAttribute('data-trustpilot-loaded', 'true');
        }
      }
    }, 100);
  }

  // Ensure those items still get the transformed flag for consistent styling/logic.
  function markTransformedIfAlreadyBuilt(item) {
    try {
      if (item.classList.contains('transformed')) return;
      const existing = item.querySelector('a.search-page-card');
      if (existing) {
        item.classList.add('transformed');
      }
    } catch (e) {
      // noop
    }
  }

// Initialize
registerAlgoliaHooks();
transformSearchPageCards();

// Consolidated search panel observer for multiple functionalities
const searchPanelObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Check for search panel creation for positioning
          if (node.classList && node.classList.contains('aa-Panel')) {
            setTimeout(updateSearchPanelPosition, 50);
          }
          
          // Algolia Recommend slider detection
          if ((node.classList && node.classList.contains('uic-HorizontalSlider-list')) ||
              (node.querySelector && node.querySelector('.uic-HorizontalSlider-list'))) {
            setTimeout(processAlgoliaRecommendCards, 100);
          }
          
          // Check for recent searches section updates - only trigger for actual recent searches
          if (node.classList?.contains('aa-PanelSection--left-top') || 
              node.querySelector?.('.aa-PanelSection--left-top')) {
            // Only update if this is actually the Recent Searches section
            const titleElement = node.querySelector?.('.aa-SourceHeaderTitle') || 
                               node.querySelector?.('.aa-PanelSection--left-top .aa-SourceHeaderTitle');
            if (titleElement && (titleElement.textContent.includes('Recent Searches') || titleElement.textContent.includes('Recent'))) {
              setTimeout(updateRecentSearchesCount, 50);
            }
          }
          
          // Check for collections header to add count
          if (node.querySelector && node.querySelector('[data-autocomplete-source-id*="collections"]')) {
            setTimeout(updateCollectionsHeaderWithCount, 50);
          }
          
          // Check for Trustpilot widgets
          if (node.querySelector && node.querySelector('.trustpilot-widget')) {
            setTimeout(initializeTrustpilotWidgets, 500);
          }
          
          // Check for new product cards to load widths
          if (node.querySelector && (node.querySelector('.search-page-card') || node.querySelector('.ais-product') || node.querySelector('.ais-Hits-item'))) {
            setTimeout(batchLoadProductWidths, 100);
          }
          if (node.querySelector && (node.querySelector('[id^="alg-recommend-wrapper_"], .uic-HorizontalSlider-list'))) {
            setTimeout(function(){
              processAlgoliaRecommendCards();
              batchLoadProductWidths();
            }, 100);
          }
        }
      });
    }
  });
});

// Update recent searches count function
function updateRecentSearchesCount() {
  // Only target the actual Recent Searches section, not the first left-top section
  const recentSearchesSection = document.querySelector('.aa-PanelSection--left-top:first-child');
  const recentList = recentSearchesSection?.querySelector('.aa-List');
  const titleElement = recentSearchesSection?.querySelector('.aa-SourceHeaderTitle');
  
  if (recentList && titleElement) {
    // Only update if this is actually the Recent Searches section
    if (titleElement.textContent.includes('Recent Searches') || titleElement.textContent.includes('Recent')) {
      const count = recentList.childElementCount;
      if (count > 0 && !titleElement.textContent.includes('(')) {
        titleElement.textContent = `Recent Searches (${count})`;
      }
    }
  }
}

// Update collections header with count from context
function updateCollectionsHeaderWithCount() {
  try {
    // Find collections source header
    const collectionsSource = document.querySelector('[data-autocomplete-source-id*="collections"]');
    if (!collectionsSource) return;
    
    const headerTitle = collectionsSource.querySelector('.aa-SourceHeaderTitle');
    if (!headerTitle) return;
    
    // Check if autocomplete instance has context with nbCollections
    const autocompleteState = window.aa?.autocomplete?.getState?.();
    const nbCollections = autocompleteState?.context?.nbCollections;
    
    if (nbCollections !== undefined && !headerTitle.textContent.includes('(')) {
      // Extract original text (e.g., "Collections" or "COLLECTIONS")
      const originalText = headerTitle.textContent.trim();
      headerTitle.textContent = `${originalText} (${nbCollections})`;
    }
  } catch (error) {
    // Silently fail if we can't update the count
    console.debug('[Collections Count] Could not update:', error);
  }
}

// Start observing
searchPanelObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// Consolidated DOMContentLoaded handler for all initialization
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Trustpilot widgets
  setTimeout(initializeTrustpilotWidgets, 1);
  
    // Decode encoded money spans coming from recommendation app (e.g., "&lt;span class=\"money\">£109.99&lt;/span>")
  try {
    const decodeEncodedMoney = () => {
      const nodes = document.querySelectorAll('.price-item.price-item--sale.price-item--last, .price-item.price-item--last');
      nodes.forEach(el => {
        if (!el) return;
        const txt = (el.textContent || '').trim();
        // If it looks like encoded HTML of a span.money, render it
        if (txt.startsWith('<span') && txt.includes('class="money"') && !el.querySelector('span.money')) {
          el.innerHTML = txt; // safe for this specific, whitelisted case
        }
      });
    };
    decodeEncodedMoney();
    const moneyObserver = new MutationObserver(() => decodeEncodedMoney());
    moneyObserver.observe(document.body, { childList: true, subtree: true });
  } catch (_) {}

  // Decode encoded widths blocks that sometimes arrive as text
  try {
    const decodeEncodedWidths = () => {
      const nodes = document.querySelectorAll('.available-widths');
      nodes.forEach(el => {
        if (!el) return;
        const txt = (el.textContent || '').trim();
        if (txt.startsWith('<div') && txt.includes('widths-container') && !el.querySelector('.widths-container')) {
          el.innerHTML = txt; // safe for this specific, whitelisted case
        }
      });
    };
    decodeEncodedWidths();
    const widthsObserver = new MutationObserver(() => decodeEncodedWidths());
    widthsObserver.observe(document.body, { childList: true, subtree: true });
  } catch (_) {}
  
  // Facet header functionality
  function bindFacetHeader(header) {
    // Skip the Selected filters header
    if (header.classList && header.classList.contains('ais-current-refined-values--header')) {
      return;
    }
    if (!header.hasAttribute('data-listener-added')) {
      header.addEventListener('click', () => {
        header.classList.toggle('open');
      });
      header.setAttribute('data-listener-added', 'true');
    }
  }

  // Initial bind
  document.querySelectorAll('.ais-facet--header').forEach(bindFacetHeader);

  // Observe Algolia container for facet headers
  const observerTarget = document.querySelector('.ais-facet-dropdown-wrapper') || document.body;
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.querySelectorAll) {
          node.querySelectorAll('.ais-facet--header').forEach(bindFacetHeader);
        }
      });
    });
  });
  observer.observe(observerTarget, { childList: true, subtree: true });

});

  // Event listeners
  document.addEventListener("algolia.hooks.initialize", registerAlgoliaHooks);
  window.addEventListener && window.addEventListener("algolia.hooks.initialize", registerAlgoliaHooks);
  document.addEventListener("algolia.hooks.ready", registerAlgoliaHooks);
  window.addEventListener && window.addEventListener("algolia.hooks.ready", registerAlgoliaHooks);
  document.addEventListener("algoliaShopify:initialized", function () {
    registerAlgoliaHooks();
    scheduleStoredFilterEnforcement();
  });
  window.addEventListener &&
    window.addEventListener("algoliaShopify:initialized", function () {
      registerAlgoliaHooks();
      scheduleStoredFilterEnforcement();
    });

  if (document.readyState === "interactive" || document.readyState === "complete") {
    setTimeout(registerAlgoliaHooks, 0);
    setTimeout(scheduleStoredFilterEnforcement, 300);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      registerAlgoliaHooks();
      scheduleStoredFilterEnforcement();
    });
  }
  document.addEventListener("page:loaded", function () {
    registerAlgoliaHooks();
    scheduleStoredFilterEnforcement();
  });

  var attempts = 0;
  var maxAttempts = 20;
  var interval = setInterval(function() {
    if (hooksRegistered) {
      clearInterval(interval);
      scheduleStoredFilterEnforcement();
      return;
    }
    attempts += 1;
    registerAlgoliaHooks();
    if (hooksRegistered || attempts >= maxAttempts) {
      clearInterval(interval);
      if (hooksRegistered) scheduleStoredFilterEnforcement();
    }
  }, 250);
})();

// Handle close button clicks only
document.addEventListener('click', (e) => {
  // Check if close button is clicked
  if (e.target.closest('.aa-CloseButton')) {
    e.preventDefault();
    e.stopPropagation();
    
    // Click on search-close element
    const searchClose = document.querySelector('.search-close');
    if (searchClose) {
      searchClose.click();
    }
    
    closeAutocomplete();
    return;
  }
});

function closeAutocomplete() {
  // Remove the autocomplete panel directly
  const aaPanel = document.querySelector('.aa-Panel');
  if (aaPanel) {
    aaPanel.remove();
  }
  
  // Restore body overflow
  document.body.style.overflow = 'auto';
  
  // Clear search input
  const searchInput = document.getElementById('searchInput');
  const algoliaInput = document.getElementById('autocomplete-0-input');
  
  if (searchInput) {
    searchInput.value = '';
    searchInput.blur();
  }
  if (algoliaInput) {
    algoliaInput.value = '';
    algoliaInput.blur();
  }
}

// Focus bridge
document.addEventListener("focusin", function(event) {
  if (!event || !event.target || event.target.id !== "searchInput") return;
  function tryFocusAutocomplete() {
    var acInput = document.getElementById("autocomplete-0-input");
    if (acInput) {
      acInput.focus();
      return true;
    }
    return false;
  }
  if (tryFocusAutocomplete()) return;
  var observer = new MutationObserver(function() {
    if (tryFocusAutocomplete()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() {
    observer.disconnect();
  }, 2000);
});

// Clear search input when focus is removed
document.addEventListener("focusout", function(event) {
  // Check if focus is moving away from search inputs
  if (event.target && (
    event.target.id === "searchInput" || 
    event.target.id === "autocomplete-0-input" ||
    event.target.classList.contains("aa-Input")
  )) {
    // Small delay to allow for potential clicks on search results
    setTimeout(function() {
      // Check if focus is still not on any search-related element
      const activeElement = document.activeElement;
      const isSearchRelated = activeElement && (
        activeElement.id === "searchInput" ||
        activeElement.id === "autocomplete-0-input" ||
        activeElement.classList.contains("aa-Input") ||
        activeElement.closest(".aa-Panel") ||
        activeElement.closest(".aa-DetachedContainer")
      );
      
      if (!isSearchRelated) {
        // Clear the search input
        const searchInput = document.getElementById("searchInput");
        const algoliaInput = document.getElementById("autocomplete-0-input");
        
        if (searchInput) {
          searchInput.value = "";
        }
        if (algoliaInput) {
          algoliaInput.value = "";
        }
        
        // Restore body overflow
        document.body.style.overflow = "auto";
        
        // Also clear any Algolia autocomplete state if available
        if (window.algoliaShopify && window.algoliaShopify.autocomplete) {
          try {
            window.algoliaShopify.autocomplete.setQuery("");
          } catch (e) {
            // Ignore errors if autocomplete is not available
          }
        }
      }
    }, 300); // 300ms delay to allow for clicks on search results
  }
});

// Trustpilot Widget Initialization
function initializeTrustpilotWidgets() {
  if (window.Trustpilot && window.Trustpilot.loadFromElement) {
    const widgets = document.querySelectorAll('.trustpilot-widget');
    widgets.forEach(widget => {
      if (!widget.hasAttribute('data-trustpilot-loaded')) {
        window.Trustpilot.loadFromElement(widget);
        widget.setAttribute('data-trustpilot-loaded', 'true');
      }
    });
  }
}

// Trustpilot initialization is now handled by the consolidated searchPanelObserver above

// Variant Popup Functionality
class VariantPopup {
  constructor() {
    this.currentProduct = null;
    this.selectedOptions = {};
    this.variants = [];
    this.init();
  }

  init() {
    this.createPopupHTML();
    this.bindEvents();
  }

  createPopupHTML() {
    const popupHTML = `
      <div id="variant-popup-overlay" class="variant-popup-overlay">
        <div class="variant-popup">
          <div class="variant-popup-header">
            <h3 class="variant-popup-title">Select Options</h3>
            <button class="variant-popup-close" type="button">&times;</button>
          </div>
          
          <div class="variant-popup-product">
            <div class="variant-popup-product-image">
              <img id="variant-popup-image" src="" alt="">
            </div>
            <div class="variant-popup-product-info">
              <h3 id="variant-popup-title"></h3>
              <p class="price" id="variant-popup-price"></p>
            </div>
          </div>
          
          <div class="variant-options" id="variant-options">
            <!-- Options will be dynamically generated -->
          </div>



          <div class="variant-popup-loading" id="variant-popup-loading">
            <div class="spinner"></div>
            <p>Adding to cart...</p>
          </div>
          
          <div class="variant-popup-actions">
            <button class="variant-popup-cancel" type="button">Cancel</button>
            <button class="variant-popup-add-to-cart" type="button" disabled>Add to Cart</button>
          </div>
          <div class="variant-popup-product-details variant-option-label product_details">         
            <a
              id="variant-popup-details-link"
              class="variant-popup-details-link"
              href="#"
              style="text-decoration:underline;"
            >
            More product details
            </a>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', popupHTML);
  }

  bindEvents() {
    // Close popup events
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('variant-popup-close') || 
          e.target.classList.contains('variant-popup-cancel') ||
          e.target.classList.contains('variant-popup-overlay')) {
        this.closePopup();
      }
    });

    // Add to cart event
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('variant-popup-add-to-cart')) {
        this.addToCart();
      }
    });

    // Variant option selection — only inside the Algolia popup.
    // PDP uses the same .color-swatch class; without this scope, selectOption
    // runs with currentProduct still null and throws.
    document.addEventListener('click', (e) => {
      const popup = e.target.closest('#variant-popup-overlay');
      if (!popup || !popup.classList.contains('active') || !this.currentProduct) return;

      if (e.target.classList.contains('variant-option-button') && !e.target.classList.contains('disabled')) {
        this.selectOption(e.target);
      }

      if (e.target.classList.contains('color-swatch')) {
        const input = e.target.previousElementSibling;
        if (input && input.classList.contains('variant__input--color-swatch') && !input.disabled) {
          this.selectOption(input);
        }
      }
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.getElementById('variant-popup-overlay').classList.contains('active')) {
        this.closePopup();
      }
    });
  }

  async openPopup(productHandle) {
    try {
      this.showLoading(true);
      
      // Fetch product data from Shopify
      const productData = await this.fetchProductData(productHandle);
      
      if (!productData) {
        console.error('Product not found');
        return;
      }

      this.currentProduct = productData;
      this.variants = productData.variants;
      this.selectedOptions = {};
      
      // Extract and cache available widths
      this.cacheAvailableWidths(productData);
      
      this.populatePopup(productData);
      this.showPopup();
      
    } catch (error) {
      console.error('Error opening variant popup:', error);
    } finally {
      this.showLoading(false);
    }
  }

  async fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error('Product not found');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  cacheAvailableWidths(productData) {
    try {
      // Find width option (look for option names containing 'width')
      const widthOption = productData.options.find(option => 
        option.name.toLowerCase().includes('width')
      );
      
      if (widthOption) {
        // Get unique width values from variants
        const widthValues = [...new Set(
          productData.variants
            .filter(variant => variant.available)
            .map(variant => {
              const optionIndex = productData.options.findIndex(opt => opt.name === widthOption.name);
              return variant.options[optionIndex];
            })
            .filter(Boolean)
        )];
        
        // Update the cache
        updateWidthsCache(productData.handle, widthValues);
      }
    } catch (error) {
      console.warn('[VariantPopup] Error caching widths:', error);
    }
  }

  populatePopup(product) {
    // Update product info
    const imageSrc = product.featured_image || (product.images && product.images[0]) || '';
    document.getElementById('variant-popup-image').src = imageSrc;
    document.getElementById('variant-popup-image').alt = product.title;
    document.getElementById('variant-popup-title').textContent = product.title;
    const detailsLink = document.getElementById('variant-popup-details-link');
    if (detailsLink) {
      detailsLink.href = `/products/${product.handle}`;
      detailsLink.textContent = 'More product details';
    }
    // Set initial price
    const firstVariant = product.variants[0];
    if (firstVariant) {
      document.getElementById('variant-popup-price').textContent = this.formatPrice(firstVariant.price);
    }
    
    // Generate variant options
    this.generateVariantOptions(product);
    
    // ✅ Set initial availability after options are rendered
    setTimeout(() => {
      this.updateOptionAvailability();
      this.updateAddToCartButton(); // Update button text on initial load
    }, 100);
  }

  generateVariantOptions(product) {
    const optionsContainer = document.getElementById('variant-options');
    optionsContainer.innerHTML = '';
    
    // Get unique option names
    const optionNames = product.options.map(option => option.name);
    
    optionNames.forEach((optionName, optionIndex) => {
      const optionGroup = document.createElement('div');
      optionGroup.className = 'variant-option-group';
      
      // Check if this is a color option
      const isColorOption = optionName.toLowerCase().includes('color') || 
                           optionName.toLowerCase().includes('colour') ||
                           optionName.toLowerCase().includes('couleur');
      
      // Create label structure
      const label = document.createElement('label');
      label.className = 'variant-option-label';
      
      if (isColorOption) {
        // Create dynamic label like PDP
        label.innerHTML = `
          ${optionName}: 
          <span class="variant__label-info">
            <span data-variant-color-label data-index="${optionIndex}">
              ${optionName}
            </span>
          </span>
        `;
      } else {
        label.textContent = optionName;
      }
      
      const buttonsContainer = document.createElement('div');
      buttonsContainer.className = isColorOption ? 'variant-input-wrap' : 'variant-option-buttons';
      
      // Get unique values for this option
      const uniqueValues = [...new Set(product.variants.map(variant => variant.options[optionIndex]))];
      
      // Pick first available value (for default label)
      let defaultValue = optionName;
      if (uniqueValues.length > 0) {
        defaultValue = uniqueValues[0];
      }
      
      if (isColorOption) {
        label.innerHTML = `
          ${optionName}: 
          <span class="variant__label-info">
            <span data-variant-color-label data-index="${optionIndex}">
              ${defaultValue}
            </span>
          </span>
        `;
      } else {
        label.textContent = optionName;
      }
      
      uniqueValues.forEach((value, idx) => {
        if (isColorOption) {
          const swatch = this.createColorSwatch(buttonsContainer, value, optionIndex, product);

          // Auto-select the first available swatch
          if (idx === 0 && !swatch.querySelector('input').classList.contains('disabled')) {
            swatch.querySelector('input').checked = true;
            this.updateColorLabel(swatch.querySelector('input'), optionIndex);
            this.selectedOptions[optionIndex] = value;
          }
        } else {
          // Regular button for non-color options
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'variant-option-button';
          button.textContent = value;
          button.dataset.optionIndex = optionIndex;
          button.dataset.optionValue = value;
          
          // Check if this option is available
          const isAvailable = product.variants.some(variant => 
            variant.options[optionIndex] === value && variant.available
          );
          
          if (!isAvailable) {
            button.classList.add('disabled');
          }
          
          buttonsContainer.appendChild(button);
        }
      });
      
      optionGroup.appendChild(label);
      optionGroup.appendChild(buttonsContainer);
      optionsContainer.appendChild(optionGroup);
    });
  }

  // Create color swatch exactly like PDP
  createColorSwatch(container, value, optionIndex, product) {
    // Create variant-input div like PDP
    const variantInput = document.createElement('div');
    variantInput.className = 'variant-input';
    variantInput.dataset.index = `option${optionIndex + 1}`;
    variantInput.dataset.value = value;
    
    // Create radio input (hidden)
    const radioInput = document.createElement('input');
    radioInput.type = 'radio';
    radioInput.className = 'variant__input--color-swatch';
    radioInput.value = value;
    radioInput.dataset.index = `option${optionIndex + 1}`;
    radioInput.name = 'Color';
    radioInput.dataset.colorName = value;
    radioInput.dataset.colorIndex = optionIndex;
    radioInput.id = `color-swatch-${value.replace(/\s+/g, '-').toLowerCase()}`;
    
    // Check if this variant is available
    const isAvailable = product.variants.some(variant => 
      variant.options[optionIndex] === value && variant.available
    );
    
    if (!isAvailable) {
      radioInput.classList.add('disabled');
    }
    
    // Create label for color swatch
    const swatchLabel = document.createElement('label');
    swatchLabel.htmlFor = radioInput.id;
    swatchLabel.className = `variant__button-label color-swatch color-swatch--${value.replace(/\s+/g, '-').toLowerCase()}${!isAvailable ? ' disabled' : ''}`;
    
    // Get color fallback and CDN image
    const colorFallback = this.getColorFallback(value);
    let colorImageUrl = '';
    
    // Find variant with this color to get its image
    const variantWithColor = product.variants.find(variant => 
      variant.options[optionIndex] === value && variant.featured_image
    );
    
    if (variantWithColor && variantWithColor.featured_image) {
      colorImageUrl = this.getCDNImageUrl(variantWithColor.featured_image);
    }
    
    // Set styles
    swatchLabel.style.backgroundColor = colorFallback;
    if (colorImageUrl) {
      swatchLabel.style.backgroundImage = `url(${colorImageUrl})`;
    }
    
    // Add color name as text (hidden by CSS)
    swatchLabel.textContent = value;
    
    // Add click handler to ensure label updates on every click
    swatchLabel.addEventListener('click', (e) => {
      // ✅ Only clickable if not disabled
      if (!radioInput.disabled && !radioInput.classList.contains('disabled')) {
        radioInput.checked = true;
        this.selectOption(radioInput);
      }
    });

    variantInput.appendChild(radioInput);
    variantInput.appendChild(swatchLabel);
    container.appendChild(variantInput);
    
    // Return the wrapper element
    return variantInput;
  }

  // Get CDN image URL exactly like PDP
  getCDNImageUrl(featuredImage) {
    if (featuredImage) {
      let imageUrl = '';
      
      // Handle different types of featured_image data
      if (typeof featuredImage === 'string') {
        imageUrl = featuredImage;
      } else if (featuredImage.src) {
        imageUrl = featuredImage.src;
      } else if (featuredImage.url) {
        imageUrl = featuredImage.url;
      } else if (featuredImage.filename) {
        // If it's a filename, construct the full URL
        imageUrl = `https://cdn.shopify.com/s/files/1/0279/3642/3981/files/${featuredImage.filename}`;
      }
      
      if (imageUrl && typeof imageUrl === 'string') {
        // If it's already a full URL, convert it to 50x50
        if (imageUrl.includes('cdn.shopify.com')) {
          return imageUrl.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/, '_50x50.$1$2');
        }
        // If it's a relative path, make it full CDN URL
        return `https://cdn.shopify.com${imageUrl.replace(/^\/+/, '/')}_50x50.jpg`;
      }
    }
    return '';
  }

  // Get color fallback exactly like PDP
  getColorFallback(value) {
    // Extract color from value (like "Sangria Red Leather" -> "leather")
    const colorFallback = value.split(' ').pop().toLowerCase();
    
    // Color mapping for common colors
    const colorMap = {
      'red': '#FF0000',
      'blue': '#0000FF', 
      'green': '#008000',
      'black': '#000000',
      'white': '#FFFFFF',
      'brown': '#8B4513',
      'gray': '#808080',
      'grey': '#808080',
      'leather': '#8B4513',
      'sangria': '#722F37',
      'burgundy': '#800020',
      'navy': '#000080',
      'tan': '#D2B48C',
      'beige': '#F5F5DC'
    };
    
    return colorMap[colorFallback] || '#' + colorFallback.replace(/[^a-f0-9]/gi, '').substring(0, 6);
  }

  selectOption(button) {
    const options = this.currentProduct && this.currentProduct.options;
    if (!button || !options) return;

    const optionIndex = parseInt(button.dataset.optionIndex || button.dataset.colorIndex, 10);
    const optionValue = button.dataset.optionValue || button.value;
    if (Number.isNaN(optionIndex) || !options[optionIndex]) return;

    // Check if this is a color selection
    const optionName = options[optionIndex].name;
    const isColorOption = optionName.toLowerCase().includes('color') || 
                         optionName.toLowerCase().includes('colour') ||
                         optionName.toLowerCase().includes('couleur');
    
    // If selecting a color, keep other selections; drop those that become invalid
    if (isColorOption) {
      this.ensureSelectionsCompatibleWithColor(optionValue, optionIndex);
    }
    
    // Handle color swatches differently
    if (button.type === 'radio' && button.classList.contains('variant__input--color-swatch')) {
      // For color swatches, update the label
      this.updateColorLabel(button, optionIndex);
    } else {
      // For regular buttons, handle selection
      const group = button.closest('.variant-option-group');
      group.querySelectorAll('.variant-option-button').forEach(btn => {
        btn.classList.remove('selected');
      });
      button.classList.add('selected');
    }
    
    // Update selected options
    this.selectedOptions[optionIndex] = optionValue;
    
    // ✅ Update availability of other options based on current selections
    this.updateOptionAvailability();
    
    // Find matching variant and update price
    this.updateVariantInfo();
    
    // Enable/disable add to cart button
    this.updateAddToCartButton();
  }

  // Clear all non-color selections when switching colors
  clearNonColorSelections() {
    const totalOptions = this.currentProduct.options.length;
    
    // Clear all selections except colors
    for (let optionIndex = 0; optionIndex < totalOptions; optionIndex++) {
      const optionName = this.currentProduct.options[optionIndex].name;
      const isColorOption = optionName.toLowerCase().includes('color') || 
                           optionName.toLowerCase().includes('colour') ||
                           optionName.toLowerCase().includes('couleur');
      
      if (!isColorOption) {
        // Clear the selection
        delete this.selectedOptions[optionIndex];
        
        // Clear visual selection
        const group = document.querySelector(`.variant-option-group:nth-child(${optionIndex + 1})`);
        if (group) {
          // Clear button selections
          group.querySelectorAll('.variant-option-button').forEach(btn => {
            btn.classList.remove('selected');
          });
          
          // Clear radio button selections
          group.querySelectorAll('.variant__input--color-swatch').forEach(radio => {
            radio.checked = false;
          });
        }
      }
    }
  }

  // Update color label when swatch is selected (like PDP)
  updateColorLabel(selectedRadio, optionIndex) {
    const colorName = selectedRadio.dataset.colorName;
    
    // Scope label lookup to the variant popup so PDP/main-product labels don't get updated
    const popupOverlay = document.getElementById('variant-popup-overlay');
    const colorLabel = popupOverlay
      ? popupOverlay.querySelector(`[data-variant-color-label][data-index="${optionIndex}"]`)
      : document.querySelector(`[data-variant-color-label][data-index="${optionIndex}"]`);
    
    if (colorLabel && colorName) {
      colorLabel.textContent = colorName;
    }
  }

  // Update availability of options based on current selections
  updateOptionAvailability() {
    if (!this.currentProduct || !this.variants) return;
    
    const totalOptions = this.currentProduct.options.length;
    
    // For each option position
    for (let optionIndex = 0; optionIndex < totalOptions; optionIndex++) {
      const optionName = this.currentProduct.options[optionIndex].name;
      const isColorOption = optionName.toLowerCase().includes('color') || 
                           optionName.toLowerCase().includes('colour') ||
                           optionName.toLowerCase().includes('couleur');
      
      // Find all possible values for this option position
      const optionValues = [...new Set(this.variants.map(v => v.options[optionIndex]))];
      
      // For each value, check if it's available given current selections
      optionValues.forEach(value => {
        // Skip the currently selected value in this option
        if (this.selectedOptions[optionIndex] === value) return;
        
        if (isColorOption) {
          // ✅ Check if color has any available sizes at all
          const hasAvailableSizes = this.colorHasAvailableSizes(value, optionIndex);
          this.updateOptionElementAvailability(optionIndex, value, hasAvailableSizes);
        } else {
          // For non-color options (size, width), check availability
          const isAvailable = this.isOptionValueAvailable(optionIndex, value);
          this.updateOptionElementAvailability(optionIndex, value, isAvailable);
        }
      });
    }
    
    // Also update already selected options' availability (for other values in same option)
    Object.keys(this.selectedOptions).forEach(selectedIndex => {
      const optionName = this.currentProduct.options[parseInt(selectedIndex)].name;
      const isColorOption = optionName.toLowerCase().includes('color') || 
                           optionName.toLowerCase().includes('colour') ||
                           optionName.toLowerCase().includes('couleur');
      
      const selectedValue = this.selectedOptions[selectedIndex];
      const allValues = [...new Set(this.variants.map(v => v.options[parseInt(selectedIndex)]))];
      
      allValues.forEach(value => {
        if (value !== selectedValue) {
          if (isColorOption) {
            // ✅ Check if color has any available sizes at all
            const hasAvailableSizes = this.colorHasAvailableSizes(value, parseInt(selectedIndex));
            this.updateOptionElementAvailability(parseInt(selectedIndex), value, hasAvailableSizes);
          } else {
            // For non-color options, check availability
            const isAvailable = this.isOptionValueAvailable(parseInt(selectedIndex), value);
            this.updateOptionElementAvailability(parseInt(selectedIndex), value, isAvailable);
          }
        }
      });
    });
  }

  // Check if a color has any available sizes at all
  colorHasAvailableSizes(colorValue, colorOptionIndex) {
    // Find all variants with this color
    const colorVariants = this.variants.filter(variant => 
      variant.options[colorOptionIndex] === colorValue && variant.available
    );
    
    // If no variants with this color are available, hide the color
    return colorVariants.length > 0;
  }

  // Check if a specific option value is available given current selections
  isOptionValueAvailable(optionIndex, optionValue) {
    const optionName = this.currentProduct.options[optionIndex].name;
    const isColorOption = optionName.toLowerCase().includes('color') || 
                         optionName.toLowerCase().includes('colour') ||
                         optionName.toLowerCase().includes('couleur');
    
    // ✅ Colors are always available (tab-like behavior)
    if (isColorOption) {
      return true;
    }
    
    // Find variants that match this option value and all currently selected options
    const matchingVariants = this.variants.filter(variant => {
      // Must match the option value we're checking
      if (variant.options[optionIndex] !== optionValue) return false;
      
      // Must match all currently selected options (except the one we're checking)
      for (let [selectedIndex, selectedValue] of Object.entries(this.selectedOptions)) {
        const idx = parseInt(selectedIndex);
        if (idx !== optionIndex && variant.options[idx] !== selectedValue) {
          return false;
        }
      }
      
      return true;
    });
    
    // Return true if at least one matching variant is available
    return matchingVariants.some(variant => variant.available);
  }

  // Update the UI element for an option to show its availability
  updateOptionElementAvailability(optionIndex, optionValue, isAvailable) {
    const optionName = this.currentProduct.options[optionIndex].name;
    const isColorOption = optionName.toLowerCase().includes('color') || 
                         optionName.toLowerCase().includes('colour') ||
                         optionName.toLowerCase().includes('couleur');
    
    // Find the element for this option
    // Check for color swatches first
    const colorSwatch = document.querySelector(
      `.variant__input--color-swatch[data-index="option${optionIndex + 1}"][value="${optionValue}"]`
    );
    
    if (colorSwatch) {
      const label = colorSwatch.nextElementSibling;
      
      if (label) {
        if (!isAvailable) {
          // ✅ For colors with no available sizes, show as disabled (not hidden)
          colorSwatch.classList.add('disabled');
          label.classList.add('disabled');
          colorSwatch.disabled = true;
        } else {
          // ✅ Remove disabled state
          colorSwatch.classList.remove('disabled');
          label.classList.remove('disabled');
          colorSwatch.disabled = false;
        }
      }
      return;
    }
    
    // Check for regular buttons
    const button = document.querySelector(
      `.variant-option-button[data-option-index="${optionIndex}"][data-option-value="${optionValue}"]`
    );
    
    if (button) {
      if (!isAvailable) {
        button.classList.add('disabled');
        button.disabled = true;
      } else {
        button.classList.remove('disabled');
        button.disabled = false;
      }
    }
  }

  updateVariantInfo() {
    const selectedVariant = this.findSelectedVariant();
    
    if (selectedVariant) {
      document.getElementById('variant-popup-price').textContent = this.formatPrice(selectedVariant.price);
      
      // Update image if variant has different image
      if (selectedVariant.featured_image) {
        document.getElementById('variant-popup-image').src = selectedVariant.featured_image.src;
      }
    }
  }

  findSelectedVariant() {
    if (Object.keys(this.selectedOptions).length === 0) {
      return this.variants[0]; // Return first variant if no options selected
    }
    
    return this.variants.find(variant => {
      return Object.entries(this.selectedOptions).every(([optionIndex, value]) => {
        return variant.options[parseInt(optionIndex)] === value;
      });
    });
  }

  updateAddToCartButton() {
    const selectedVariant = this.findSelectedVariant();
    const addToCartBtn = document.querySelector('.variant-popup-add-to-cart');
    
    // Check if all required options are selected
    const totalOptions = this.currentProduct.options.length;
    const allOptionsSelected = Object.keys(this.selectedOptions).length === totalOptions;
    
    // ✅ Edge Case: Check if selected color has no available sizes/widths
    const hasUnselectableOptions = this.hasUnselectableOptions();
    
    // ✅ PRIORITY 1: Edge Case - agar koi option select hi nahi kar sakte (all disabled)
    if (hasUnselectableOptions) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    }
    // ✅ PRIORITY 2: Agar variant available hai AUR sab options selected hain
    else if (selectedVariant && selectedVariant.available && allOptionsSelected) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart';
    }
    // ✅ PRIORITY 3: Agar kuch options missing hain
    else if (!allOptionsSelected) {
      addToCartBtn.disabled = true;
      // Show specific prompt for the first missing option
      const total = this.currentProduct.options.length;
      let missingText = 'Select Options';
      for (let i = 0; i < total; i++) {
        if (this.selectedOptions[i] === undefined) {
          const name = (this.currentProduct.options[i].name || '').toLowerCase();
          if (name.includes('color') || name.includes('colour') || name.includes('couleur')) {
            missingText = 'Select Colour';
          } else if (name.includes('size')) {
            missingText = 'Select Size';
          } else if (name.includes('width')) {
            missingText = 'Select Width';
          }
          break;
        }
      }
      addToCartBtn.textContent = missingText;
    }
    // ✅ PRIORITY 4: Sab selected but variant sold out
    else if (selectedVariant && !selectedVariant.available) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    }
    // ✅ PRIORITY 5: Fallback
    else {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Select Options';
    }
  }

  // ✅ Check if there are options that cannot be selected (all disabled)
  hasUnselectableOptions() {
    const totalOptions = this.currentProduct.options.length;
    
    for (let optionIndex = 0; optionIndex < totalOptions; optionIndex++) {
      const optionName = this.currentProduct.options[optionIndex].name;
      const isColorOption = optionName.toLowerCase().includes('color') || 
                           optionName.toLowerCase().includes('colour') ||
                           optionName.toLowerCase().includes('couleur');
      
      // Skip color options (they're navigation tabs)
      if (isColorOption) continue;
      
      // Check if this option is already selected
      if (this.selectedOptions[optionIndex]) continue;
      
      // Get all possible values for this option
      const optionValues = [...new Set(this.variants.map(v => v.options[optionIndex]))];
      
      // Check if ALL values are unavailable
      const allUnavailable = optionValues.every(value => {
        return !this.isOptionValueAvailable(optionIndex, value);
      });
      
      // If all values for this option are unavailable, it's unselectable
      if (allUnavailable && optionValues.length > 0) {
        return true;
      }
    }
    
    return false;
  }

  async addToCart() {
    const selectedVariant = this.findSelectedVariant();
    
    if (!selectedVariant || !selectedVariant.available) {
      return;
    }
    
    try {
      this.showLoading(true);

      const payload = {
        id: selectedVariant.id,
        quantity: 1
      };

      const sizeProperty =
        window.theme && typeof theme.getVariantSizeProperty === 'function'
          ? theme.getVariantSizeProperty(this.currentProduct, selectedVariant)
          : null;

      if (sizeProperty) {
        payload.properties = { Size: sizeProperty };
      }
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        const item = await response.json();
        
        // Success - close popup and show success message
        this.closePopup();
        this.showSuccessMessage();
        
        // ✅ Use theme.js cart update pattern
        this.refreshCartLikeTheme();
        
      } else {
        throw new Error('Failed to add to cart');
      }
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error adding this item to your cart. Please try again.');
    } finally {
      this.showLoading(false);
    }
  }

  showSuccessMessage() {
    // Create a simple success notification
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #059669;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      z-index: 10000;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    `;
    notification.textContent = 'Added to cart!';
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  async refreshCartLikeTheme() {
    try {
      // Method 1: Trigger the same event that theme.js uses
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { 
          product: this.currentProduct,
          variant: this.findSelectedVariant()
        }
      }));

      // Method 2: If theme.cart exists, use its buildCart method
      if (window.theme && window.theme.cart && window.theme.cart.buildCart) {
        window.theme.cart.buildCart();
      }

      // Method 3: If CartDrawer exists, trigger its cart form build
      if (window.theme && window.theme.CartDrawer) {
        const cartDrawer = document.querySelector('#CartDrawer');
        if (cartDrawer && cartDrawer.cartForm) {
          cartDrawer.cartForm.buildCart();
        }
      }

      // Method 4: Dispatch cart:updated event like theme.js does
      this.fetchCartAndDispatchEvent();
      
    } catch (error) {
      console.error('Error refreshing cart like theme:', error);
    }
  }

  async fetchCartAndDispatchEvent() {
    try {
      // Fetch cart data like theme.js does
      const response = await fetch('/cart.js');
      if (response.ok) {
        const parsedCart = await response.json();
        
        // Dispatch the same event that theme.js dispatches
        document.dispatchEvent(new CustomEvent("cart:updated", {
          detail: {
            cart: parsedCart,
          },
        }));

        // Also dispatch cart:open to open the drawer
        document.dispatchEvent(new CustomEvent("cart:open"));
      }
    } catch (error) {
      console.error('Error fetching cart and dispatching event:', error);
    }
  }

  showPopup() {
    document.getElementById('variant-popup-overlay').classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    document.getElementById('variant-popup-overlay').classList.remove('active');
    document.body.style.overflow = '';
  }

  showLoading(show) {
    const loading = document.getElementById('variant-popup-loading');
    const actions = document.querySelector('.variant-popup-actions');
    
    if (show) {
      loading.classList.add('active');
      actions.style.display = 'none';
    } else {
      loading.classList.remove('active');
      actions.style.display = 'flex';
    }
  }

  formatPrice(price) {
    // Get the current store currency from Shopify's global settings
    const currentCurrency = window.Shopify?.currency?.active || 'GBP';
    const currencyCode = currentCurrency.toLowerCase();
    
    // Map currency codes to their respective locales and symbols
    const currencyMap = {
      'gbp': { locale: 'en-GB', symbol: '£' },
      'usd': { locale: 'en-US', symbol: '$' },
      'eur': { locale: 'en-EU', symbol: '€' },
      'inr': { locale: 'en-IN', symbol: '₹' },
      'cad': { locale: 'en-CA', symbol: 'C$' },
      'aud': { locale: 'en-AU', symbol: 'A$' }
    };
    
    const currencyInfo = currencyMap[currencyCode] || currencyMap['gbp'];
    
    try {
      const formattedPrice = new Intl.NumberFormat(currencyInfo.locale, {
        style: 'currency',
        currency: currentCurrency.toUpperCase()
      }).format(price / 100);
      
      // Return price with proper currency symbol
      return formattedPrice.replace(currencyInfo.symbol, currencyInfo.symbol + ' ');
    } catch (error) {
      // Fallback to simple formatting
      return `${currencyInfo.symbol}${(price / 100).toFixed(2)}`;
    }
  }

  // Ensure that previously selected non-color options remain compatible with newly selected color
  ensureSelectionsCompatibleWithColor(selectedColor, colorOptionIndex) {
    const totalOptions = this.currentProduct.options.length;

    for (let optionIndex = 0; optionIndex < totalOptions; optionIndex++) {
      if (optionIndex === colorOptionIndex) continue;

      const previouslySelected = this.selectedOptions[optionIndex];
      if (!previouslySelected) continue;

      const stillAvailable = this.variants.some(v => {
        return v.available && v.options[colorOptionIndex] === selectedColor && v.options[optionIndex] === previouslySelected;
      });

      if (!stillAvailable) {
        delete this.selectedOptions[optionIndex];
        const group = document.querySelector(`.variant-option-group:nth-child(${optionIndex + 1})`);
        if (group) {
          group.querySelectorAll('.variant-option-button.selected').forEach(btn => btn.classList.remove('selected'));
          group.querySelectorAll('.variant__input--color-swatch').forEach(radio => { radio.checked = false; });
        }
      }
    }
  }
}

// Helper function to generate widths HTML
function sortWidthsByLeadingNumber(widths) {
  if (!Array.isArray(widths)) return [];

  return [...widths].sort((a, b) => {
    const aText = String(a || '').trim();
    const bText = String(b || '').trim();
    const aMatch = aText.match(/^(\d+)/);
    const bMatch = bText.match(/^(\d+)/);
    const aKey = aMatch ? parseInt(aMatch[1], 10) : Number.MAX_SAFE_INTEGER;
    const bKey = bMatch ? parseInt(bMatch[1], 10) : Number.MAX_SAFE_INTEGER;

    if (aKey !== bKey) return aKey - bKey;
    return aText.localeCompare(bText, undefined, { numeric: true, sensitivity: 'base' });
  });
}

function generateWidthsHTML(widths) {
  const sortedWidths = sortWidthsByLeadingNumber(widths);

  if (sortedWidths && sortedWidths.length > 0) {
    return `
      <div class="widths-container">
        <div class="widths-list">
          ${sortedWidths.map(width => `<span class="width-badge">${width}</span>`).join('')}
        </div>
      </div>
    `;
  }
  return '';
}

// Helper function to get available widths for a product
function getAvailableWidthsForProduct(productHandle, useCache = true) {
  try {
    // Check if we have cached product data (only if useCache is true)
    if (useCache && window.productWidthsCache && window.productWidthsCache[productHandle]) {
      return window.productWidthsCache[productHandle];
    }
    
    // Initialize cache if it doesn't exist
    if (!window.productWidthsCache) {
      window.productWidthsCache = {};
    }
    
    // Proactively fetch widths if not cached
    fetchProductWidths(productHandle);
    
    return [];
  } catch (error) {
    console.warn('[Widths] Error getting widths for product:', productHandle, error);
    return [];
  }
}

// Function to proactively fetch product widths
async function fetchProductWidths(productHandle) {
  try {
    // Avoid duplicate requests
    if (window.widthsFetching && window.widthsFetching[productHandle]) {
      return;
    }
    
    if (!window.widthsFetching) {
      window.widthsFetching = {};
    }
    window.widthsFetching[productHandle] = true;
    
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error('Product not found');
    }
    
    const productData = await response.json();
    
    // Extract widths using the same logic as variant popup
    const widthOption = productData.options.find(option => 
      option.name.toLowerCase().includes('width')
    );
    
    if (widthOption) {
      const widthValues = [...new Set(
        productData.variants
          .filter(variant => variant.available)
          .map(variant => {
            const optionIndex = productData.options.findIndex(opt => opt.name === widthOption.name);
            return variant.options[optionIndex];
          })
          .filter(Boolean)
      )];
      
      // Update the cache
      updateWidthsCache(productHandle, widthValues);
    }
    
  } catch (error) {
    console.warn('[Widths] Error fetching widths for product:', productHandle, error);
  } finally {
    // Clear the fetching flag
    if (window.widthsFetching) {
      delete window.widthsFetching[productHandle];
    }
  }
}

// Function to update widths cache when variant popup loads product data
function updateWidthsCache(productHandle, widths) {
  if (!window.productWidthsCache) {
    window.productWidthsCache = {};
  }
  const sortedWidths = sortWidthsByLeadingNumber(widths);
  window.productWidthsCache[productHandle] = sortedWidths;
  
  // Update all product cards with this handle
  const nodeListA = document.querySelectorAll(`[data-product-handle="${productHandle}"] .available-widths`);
  const nodeListB = document.querySelectorAll(`.available-widths[data-product-handle="${productHandle}"]`);
  const widthElements = Array.from(new Set([...
    Array.from(nodeListA),
    Array.from(nodeListB)
  ].flat()));
  widthElements.forEach(element => {
    element.innerHTML = generateWidthsHTML(sortedWidths);
  });
}

// Function to batch load widths for all visible products
function batchLoadProductWidths() {
  // Get all product handles from visible product cards
  const productHandles = new Set();
  
  // Check search page cards
  const searchCards = document.querySelectorAll('.search-page-card[data-product-handle]');
  searchCards.forEach(card => {
    const handle = card.getAttribute('data-product-handle');
    if (handle) productHandles.add(handle);
  });
  
  // Check autocomplete cards
  const autocompleteCards = document.querySelectorAll('.ais-product[data-product-handle]');
  autocompleteCards.forEach(card => {
    const handle = card.getAttribute('data-product-handle');
    if (handle) productHandles.add(handle);
  });
  
  // Check hits cards
  const hitsCards = document.querySelectorAll('.ais-Hits-item a[data-product-handle]');
  hitsCards.forEach(card => {
    const handle = card.getAttribute('data-product-handle');
    if (handle) productHandles.add(handle);
  });
  
  // Fetch widths for all unique product handles
  productHandles.forEach(handle => {
    if (!window.productWidthsCache || !window.productWidthsCache[handle]) {
      fetchProductWidths(handle);
    }
  });
}

// =====================
// Algolia Recommend: Enhance cards with widths + quick-buy
// =====================

function getColorFromProductData(productData) {
  try {
    if (!productData) return '';
    const options = Array.isArray(productData.options) ? productData.options : [];
    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const colorOptionIndex = options.findIndex(
      (opt) =>
        (opt?.name || '').toLowerCase().includes('color') ||
        (opt?.name || '').toLowerCase().includes('colour')
    );
    if (colorOptionIndex > -1) {
      const availableVariant =
        variants.find((variant) => variant && variant.available) || variants[0];
      if (
        availableVariant &&
        Array.isArray(availableVariant.options) &&
        availableVariant.options[colorOptionIndex]
      ) {
        return String(availableVariant.options[colorOptionIndex]).trim();
      }
      const optionValues = options[colorOptionIndex]?.values || [];
      if (Array.isArray(optionValues) && optionValues[0]) {
        return String(optionValues[0]).trim();
      }
    }
  } catch (_) {}
  return '';
}

async function fetchProductColor(productHandle) {
  try {
    if (!productHandle) return '';
    if (window.productColorCache && window.productColorCache[productHandle]) {
      return window.productColorCache[productHandle];
    }
    if (!window.productColorCache) window.productColorCache = {};
    if (!window.colorFetching) window.colorFetching = {};
    if (window.colorFetching[productHandle]) return '';
    window.colorFetching[productHandle] = true;
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) throw new Error('Product not found');
    const productData = await response.json();
    const color = getColorFromProductData(productData);
    if (color) window.productColorCache[productHandle] = color;
    return color || '';
  } catch (_) {
    return '';
  } finally {
    if (window.colorFetching) delete window.colorFetching[productHandle];
  }
}

function parseNullableBool(value) {
  if (value == null) return null;
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (!normalized) return null;
    if (normalized === 'true' || normalized === 'yes') return true;
    if (normalized === 'false' || normalized === 'no') return false;
  }
  return null;
}

function getAlgoliaProductsIndexName() {
  const prefix = window.algoliaShopify?.config?.index_prefix || '';
  return prefix ? `${prefix}products` : '';
}

function resolveRecommendAltTagsFlag(cardWrapper, productLink, recommendImage, handle, productId) {
  try {
    const attrValue =
      cardWrapper.getAttribute('data-product-image-alt-tags') ||
      (productLink && productLink.getAttribute('data-product-image-alt-tags')) ||
      (recommendImage && recommendImage.getAttribute('data-product-image-alt-tags'));
    if (attrValue != null && String(attrValue).trim() !== '') {
      return parseNullableBool(attrValue);
    }

    const readFromHitJson = (node) => {
      if (!node || !node.getAttribute) return null;
      const hitDataStr = node.getAttribute('data-hit');
      if (!hitDataStr) return null;
      try {
        const hitData = JSON.parse(hitDataStr);
        const raw =
          hitData?.meta?.custom?.product_image_alt_tags ??
          hitData?.custom?.product_image_alt_tags ??
          hitData?.metafields?.custom?.product_image_alt_tags ??
          hitData?.product_image_alt_tags;
        if (raw == null || raw === '') return null;
        return parseNullableBool(raw);
      } catch (_) {
        return null;
      }
    };

    const fromCardHit = readFromHitJson(cardWrapper);
    if (fromCardHit !== null) return fromCardHit;
    const fromLinkHit = readFromHitJson(productLink);
    if (fromLinkHit !== null) return fromLinkHit;
    const fromImageHit = readFromHitJson(recommendImage);
    if (fromImageHit !== null) return fromImageHit;

    const hits = window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.hits || [];
    if (Array.isArray(hits) && hits.length > 0) {
      const normalizedHandle = String(handle || '').toLowerCase();
      const normalizedProductId = String(productId || '');
      const matchedHit =
        hits.find((h) => {
          const hitHandle = String(h?.handle || '').toLowerCase();
          const hitProductId = String(h?.product_id || h?.id || h?.objectID || '');
          if (normalizedHandle && hitHandle === normalizedHandle) return true;
          if (normalizedProductId && hitProductId === normalizedProductId) return true;
          return false;
        }) || null;
      if (matchedHit) {
        const raw =
          matchedHit?.meta?.custom?.product_image_alt_tags ??
          matchedHit?.custom?.product_image_alt_tags ??
          matchedHit?.metafields?.custom?.product_image_alt_tags ??
          matchedHit?.product_image_alt_tags;
        if (raw != null && raw !== '') return parseNullableBool(raw);
      }
    }
  } catch (_) {}
  return null;
}

// Each lookup is a billable Algolia search, so results (including "no flag") are cached in memory and
// sessionStorage, and concurrent lookups for the same product share one request.
const RECOMMEND_ALT_TAGS_STORAGE_KEY = 'recommendAltTagsFlags';

function readRecommendAltTagsStorage() {
  try {
    return JSON.parse(sessionStorage.getItem(RECOMMEND_ALT_TAGS_STORAGE_KEY) || '{}') || {};
  } catch (_) {
    return {};
  }
}

function writeRecommendAltTagsStorage(cacheKey, value) {
  try {
    const stored = readRecommendAltTagsStorage();
    stored[cacheKey] = value;
    sessionStorage.setItem(RECOMMEND_ALT_TAGS_STORAGE_KEY, JSON.stringify(stored));
  } catch (_) {}
}

function fetchRecommendAltTagsFlagFromAlgolia(handle, productId) {
  if (!handle && !productId) return Promise.resolve(null);
  if (!window.recommendAltTagsCache) window.recommendAltTagsCache = {};
  if (!window.recommendAltTagsInflight) window.recommendAltTagsInflight = {};
  const cacheKey = String(handle || productId || '').trim();
  if (!cacheKey) return Promise.resolve(null);

  if (Object.prototype.hasOwnProperty.call(window.recommendAltTagsCache, cacheKey)) {
    return Promise.resolve(window.recommendAltTagsCache[cacheKey]);
  }
  const stored = readRecommendAltTagsStorage();
  if (Object.prototype.hasOwnProperty.call(stored, cacheKey)) {
    window.recommendAltTagsCache[cacheKey] = stored[cacheKey];
    return Promise.resolve(stored[cacheKey]);
  }
  if (window.recommendAltTagsInflight[cacheKey]) return window.recommendAltTagsInflight[cacheKey];

  const request = requestRecommendAltTagsFlagFromAlgolia(handle, productId).then((resolved) => {
    // resolved is true/false, or null when the product has no flag; cache all three outcomes
    window.recommendAltTagsCache[cacheKey] = resolved;
    writeRecommendAltTagsStorage(cacheKey, resolved);
    delete window.recommendAltTagsInflight[cacheKey];
    return resolved;
  });
  window.recommendAltTagsInflight[cacheKey] = request;
  return request;
}

async function requestRecommendAltTagsFlagFromAlgolia(handle, productId) {
  try {
    const appId =
      window.algoliaShopify?.config?.app_id ||
      window.algoliaShopify?.config?.application_id ||
      window.algoliaShopify?.config?.appId;
    const apiKey =
      window.algoliaShopify?.config?.search_api_key ||
      window.algoliaShopify?.config?.searchApiKey ||
      window.algoliaShopify?.config?.api_key;
    const indexName = getAlgoliaProductsIndexName();
    if (!appId || !apiKey || !indexName) return null;
    // One search per product: the handle is preferred, the product id is only used when there is no handle
    const response = await fetch(
      `https://${appId}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Algolia-API-Key': apiKey,
          'X-Algolia-Application-Id': appId,
        },
        body: JSON.stringify({
          query: String(handle || productId),
          hitsPerPage: 8,
          attributesToRetrieve: [
            'handle', 'id', 'product_id', 'objectID',
            'meta', 'custom', 'metafields', 'product_image_alt_tags',
          ],
        }),
      }
    );
    if (!response.ok) return null;
    const data = await response.json();
    const hits = Array.isArray(data.hits) ? data.hits : [];
    if (!hits.length) return null;
    const normalizedHandle = String(handle || '').toLowerCase();
    const normalizedProductId = String(productId || '');
    const matchedHit =
      hits.find((hit) => {
        const hitHandle = String(hit?.handle || '').toLowerCase();
        const hitProductId = String(hit?.product_id || hit?.id || hit?.objectID || '');
        if (normalizedHandle && hitHandle === normalizedHandle) return true;
        if (normalizedProductId && hitProductId === normalizedProductId) return true;
        return false;
      }) || hits[0];
    const raw =
      matchedHit?.meta?.custom?.product_image_alt_tags ??
      matchedHit?.custom?.product_image_alt_tags ??
      matchedHit?.metafields?.custom?.product_image_alt_tags ??
      matchedHit?.product_image_alt_tags;
    return parseNullableBool(raw);
  } catch (_) {
    return null;
  }
}

function getHandleFromHref(href) {
  try {
    if (!href) return '';
    const a = document.createElement('a');
    a.href = href;
    const match = a.pathname.match(/\/products\/([^\/?#]+)/i);
    return match ? match[1] : '';
  } catch (_) {
    return '';
  }
}

function enhanceRecommendCard(cardWrapper) {
  try {
    if (!cardWrapper || cardWrapper.classList.contains('alg-recommend-processed')) return;

    // Find a product link to extract handle
    const productLink = cardWrapper.querySelector('a[href*="/products/"]');
    const handle = productLink ? getHandleFromHref(productLink.getAttribute('href')) : '';
    if (!handle) return;

    const productId =
      cardWrapper.getAttribute('data-product-id') ||
      cardWrapper.getAttribute('data-productid') ||
      (productLink && (productLink.getAttribute('data-product-id') || productLink.getAttribute('data-productid'))) ||
      '';

    const recommendImage = cardWrapper.querySelector('.aa-ItemPicture img, .card__media img, .card-media img, img');
    let useTitleOnlyAlt = resolveRecommendAltTagsFlag(cardWrapper, productLink, recommendImage, handle, productId);

    if (recommendImage) {
      const titleEl = cardWrapper.querySelector('.aa-ItemContentTitle, .card__heading, .full-unstyled-link, .card-information__text');
      const productName = titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';
      let colorName =
        cardWrapper.getAttribute('data-color') ||
        cardWrapper.getAttribute('data-product-color') ||
        (productLink && productLink.getAttribute('data-color')) ||
        recommendImage.getAttribute('data-color') ||
        '';
      if (!colorName) {
        const variantTextEl = cardWrapper.querySelector('.algolia-variant, [data-variant-title], .card-variant, .variant-title');
        const variantText = variantTextEl ? variantTextEl.textContent.trim().replace(/\s+/g, ' ') : '';
        if (variantText) {
          const cleanedVariantText = variantText.replace(/^-+\s*/, '');
          colorName = cleanedVariantText.split('/')[0].split('(')[0].trim();
        }
      }
      const imagePosition =
        cardWrapper.getAttribute('data-image-position') ||
        recommendImage.getAttribute('data-image-position') ||
        '1';
      const generatedAlt = `${productName || 'Product'} in ${colorName} - Image ${imagePosition}`;
      const finalAlt = useTitleOnlyAlt
        ? (productName || 'Product').trim()
        : generatedAlt;

      recommendImage.setAttribute('alt', finalAlt);
      if (useTitleOnlyAlt === true || useTitleOnlyAlt === false) {
        cardWrapper.setAttribute('data-product-image-alt-tags', useTitleOnlyAlt ? 'true' : 'false');
      }
      cardWrapper.setAttribute('data-product-image-alt', finalAlt);

      fetchRecommendAltTagsFlagFromAlgolia(handle, productId).then((resolvedFlag) => {
        if (resolvedFlag == null) return;
        const correctedAlt = resolvedFlag
          ? (productName || 'Product').trim()
          : `${productName || 'Product'} in ${colorName} - Image ${imagePosition}`;
        recommendImage.setAttribute('alt', correctedAlt);
        cardWrapper.setAttribute('data-product-image-alt-tags', resolvedFlag ? 'true' : 'false');
        cardWrapper.setAttribute('data-product-image-alt', correctedAlt);
      });

      if (!colorName && useTitleOnlyAlt !== true) {
        fetchProductColor(handle).then((fetchedColor) => {
          if (!fetchedColor) return;
          const refreshedAlt = `${productName || 'Product'} in ${fetchedColor} - Image ${imagePosition}`;
          recommendImage.setAttribute('alt', refreshedAlt);
          cardWrapper.setAttribute('data-product-color', fetchedColor);
          cardWrapper.setAttribute('data-product-image-alt', refreshedAlt);
        });
      }
    }

    // Helper to pick visible target if duplicates exist
    function pickVisible(selectors) {
      for (const sel of selectors) {
        const el = cardWrapper.querySelector(sel);
        if (el) {
          try {
            const style = window.getComputedStyle(el);
            if (!style || style.display !== 'none' && style.visibility !== 'hidden') return el;
          } catch (_) {
            return el;
          }
        }
      }
      return null;
    }

    // 1) Ensure widths container exists and fill from cache/fetch
    let widthsContainer = cardWrapper.querySelector('.available-widths');
    if (!widthsContainer) {
      // Prefer the visible lower content area near price/vendor
      const priceBlock = pickVisible([
        '.card__content:last-of-type .card-information',
        '.card-information',
        '.card__content:last-of-type .card__information',
        '.card-information-data'
      ]);
      widthsContainer = document.createElement('div');
      widthsContainer.className = 'available-widths';
      widthsContainer.setAttribute('data-product-handle', handle);
      if (priceBlock) {
        // Place widths after price block container
        priceBlock.parentNode.appendChild(widthsContainer);
      } else {
        cardWrapper.appendChild(widthsContainer);
      }
    }
    widthsContainer.innerHTML = generateWidthsHTML(getAvailableWidthsForProduct(handle));

    // 2) Ensure quick-buy button with hd-Banner_Icon exists
    let quickBtn = cardWrapper.querySelector('.aa-ItemContentQuickbuyMobile');
    if (!quickBtn) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'prd-Card_QuickBuyTrigger aa-ItemContentQuickbuyMobile';
      btn.setAttribute('data-product-handle', handle);
      btn.innerHTML = '<span class="hd-Banner_Icon">\n        <svg id="baoIconBag" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">\n          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 19H16.75L15.711 6.53157C15.6624 5.9485 15.175 5.5 14.5899 5.5H3.16015C2.57505 5.5 2.08763 5.9485 2.03904 6.53157L1 19Z" stroke="currentColor"></path>\n          <path fill="transparent" d="M12 7C12 6.24543 12 4.43578 12 2.99988C12 1.89531 11.1046 1 10 1H8.00002C6.89545 1 6.00002 1.89543 6.00002 3V7" stroke="currentColor" stroke-linecap="square"></path>\n        </svg>\n        <svg id="baoIconEye" class="icon-eye" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">\n          <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7z" stroke="currentColor" stroke-width="2" fill="none" />\n          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>\n        </svg>\n      </span>';

      // Prefer vendor row so it can be flexed with vendor
      const visibleInfo = pickVisible([
        '.card__content:last-of-type .card__information',
        '.card-information-data',
        '.card__content .card__information:last-of-type'
      ]);
      const vendor = cardWrapper.querySelector('.card-information .card-vendor, .card-vendor');

      if (vendor && vendor.parentNode) {
        let vendorRow = vendor.closest('.card-vendor-row');
        if (!vendorRow) {
          vendorRow = document.createElement('div');
          vendorRow.className = 'card-vendor-row';
          vendor.parentNode.insertBefore(vendorRow, vendor);
          vendorRow.appendChild(vendor);
        }
        vendorRow.appendChild(btn);
      } else if (visibleInfo) {
        visibleInfo.appendChild(btn);
      } else {
        cardWrapper.appendChild(btn);
      }
      quickBtn = btn;
    } else {
      // Move existing button out of hidden block if needed
      const parentInfo = quickBtn.closest('.card__information');
      if (parentInfo) {
        try {
          const style = window.getComputedStyle(parentInfo);
          if (style && style.display === 'none') {
            const vendor = cardWrapper.querySelector('.card-information .card-vendor, .card-vendor');
            const visibleInfo = pickVisible([
              '.card__content:last-of-type .card__information',
              '.card-information-data',
              '.card__content .card__information:last-of-type'
            ]);
            if (vendor && vendor.parentNode) {
              let vendorRow = vendor.closest('.card-vendor-row');
              if (!vendorRow) {
                vendorRow = document.createElement('div');
                vendorRow.className = 'card-vendor-row';
                vendor.parentNode.insertBefore(vendorRow, vendor);
                vendorRow.appendChild(vendor);
              }
              vendorRow.appendChild(quickBtn);
            } else if (visibleInfo) {
              visibleInfo.appendChild(quickBtn);
            }
          }
        } catch (_) {}
      }
    }

    cardWrapper.classList.add('alg-recommend-processed');

    if (!window.productWidthsCache || !window.productWidthsCache[handle]) {
      fetchProductWidths(handle);
    }
  } catch (e) {}
}

function processAlgoliaRecommendCards() {
  try {
    const wrappers = document.querySelectorAll('[id^="alg-recommend-wrapper_"], .uic-HorizontalSlider-list');
    wrappers.forEach((wrapper) => {
      const cards = wrapper.querySelectorAll(
        '.uic-HorizontalSlider-item .card-wrapper, .product-card-wrapper, .card-wrapper'
      );
      cards.forEach((cardWrapper) => {
        try {
          const productLink = cardWrapper.querySelector('a[href*="/products/"]');
          const recommendImage = cardWrapper.querySelector(
            '.aa-ItemPicture img, .card__media img, .card-media img, img'
          );
          if (productLink && recommendImage) {
            const handle = getHandleFromHref(productLink.getAttribute('href'));
            const productId =
              cardWrapper.getAttribute('data-product-id') ||
              cardWrapper.getAttribute('data-productid') ||
              productLink.getAttribute('data-product-id') ||
              productLink.getAttribute('data-productid') ||
              '';
            const titleEl = cardWrapper.querySelector(
              '.aa-ItemContentTitle, .card__heading, .full-unstyled-link, .card-information__text'
            );
            const productName = titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';
            let colorName =
              cardWrapper.getAttribute('data-color') ||
              cardWrapper.getAttribute('data-product-color') ||
              productLink.getAttribute('data-color') ||
              recommendImage.getAttribute('data-color') ||
              '';
            if (!colorName) {
              const variantTextEl = cardWrapper.querySelector(
                '.algolia-variant, [data-variant-title], .card-variant, .variant-title'
              );
              const variantText = variantTextEl ? variantTextEl.textContent.trim().replace(/\s+/g, ' ') : '';
              if (variantText) {
                const cleanedVariantText = variantText.replace(/^-+\s*/, '');
                colorName = cleanedVariantText.split('/')[0].split('(')[0].trim();
              }
            }
            const imagePosition =
              cardWrapper.getAttribute('data-image-position') ||
              recommendImage.getAttribute('data-image-position') ||
              '1';
            const generatedAlt = `${productName || 'Product'} in ${colorName} - Image ${imagePosition}`;
            const resolvedFlag = resolveRecommendAltTagsFlag(
              cardWrapper, productLink, recommendImage, handle, productId
            );
            const useTitleOnlyAlt = resolvedFlag === true;
            const finalAlt = useTitleOnlyAlt ? (productName || 'Product').trim() : generatedAlt;
            recommendImage.setAttribute('alt', finalAlt);
            if (resolvedFlag === true || resolvedFlag === false) {
              cardWrapper.setAttribute('data-product-image-alt-tags', useTitleOnlyAlt ? 'true' : 'false');
            }
            cardWrapper.setAttribute('data-product-image-alt', finalAlt);

            if (resolvedFlag == null) {
              fetchRecommendAltTagsFlagFromAlgolia(handle, productId).then((flag) => {
                if (flag == null) return;
                const correctedAlt = flag ? (productName || 'Product').trim() : generatedAlt;
                recommendImage.setAttribute('alt', correctedAlt);
                cardWrapper.setAttribute('data-product-image-alt-tags', flag ? 'true' : 'false');
                cardWrapper.setAttribute('data-product-image-alt', correctedAlt);
              });
            }
          }
        } catch (_) {}
        enhanceRecommendCard(cardWrapper);
      });
    });
  } catch (_) {}
}

// Initialize variant popup
const variantPopup = new VariantPopup();

// Algolia Pagination Integration following official documentation
(function() {
  
  // Wait for Algolia to be ready
  function waitForAlgolia() {
    return new Promise((resolve) => {
      const checkAlgolia = () => {
        if (window.algoliaShopify && window.algoliaShopify.hooks) {
          resolve();
        } else {
          setTimeout(checkAlgolia, 100);
        }
      };
      checkAlgolia();
    });
  }
  
  // Wait for InstantSearch widgets
  function waitForInstantSearch() {
    return new Promise((resolve) => {
      const checkInstantSearch = () => {
        if (window.instantsearch && window.instantsearch.widgets && window.instantsearch.widgets.hits && window.instantsearch.widgets.pagination) {
          resolve();
        } else {
          setTimeout(checkInstantSearch, 100);
        }
      };
      checkInstantSearch();
    });
  }
  
  // Initialize infinite scroll following official docs
  async function initializePagination() {
    try {
      await Promise.all([waitForAlgolia(), waitForInstantSearch()]);
      
      const { hits, pagination } = window.instantsearch.widgets;
      
      // Register hook to modify widgets array
      algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function(widgets) {
        
        // Filter out any conflicting widgets
        const filteredWidgets = widgets.filter(widget => {
          if (widget && widget.$$type) {
            // Remove any infinite hits or conflicting widgets
            if (widget.$$type === 'ais.infiniteHits') {
              return false;
            }
          }
          return true;
        });
        
        
        // Find the correct container for hits
        const findContainer = () => {
          const possibleContainers = [
            '#hits',
            '.ais-hits-container', 
            '.product-grid',
            '.collection-products',
            '.ais-Hits',
            '[data-hits-container]',
            '.search-results',
            '.products-container'
          ];
          
          for (const selector of possibleContainers) {
            const element = document.querySelector(selector);
            if (element) {
              return element;
            }
          }
          
          // If no container found, create one
          const fallbackContainer = document.createElement('div');
          fallbackContainer.className = 'ais-hits-container';
          fallbackContainer.id = 'hits';
          
          // Try to insert it where products should be
          const searchResults = document.querySelector('.search-results, .collection-template, .template-search, .template-collection, .template-page');
          if (searchResults) {
            searchResults.appendChild(fallbackContainer);
            return fallbackContainer;
          }
          
          // Last resort - append to body
          document.body.appendChild(fallbackContainer);
          return fallbackContainer;
        };
        
        const container = findContainer();
        
        // Create hits widget with pagination
        try {
          const hitsWidget = hits({
            container: container,
            templates: {
              item(hit, { html, components }) {
                // Optimized template rendering
                
            // Simplified template for better performance
            try {
              const distinct = window.algoliaShopify?.instantsearch?.distinct || false;
              const itemLink = hit.url || `/products/${hit.handle}`;
              const templateOptions = { html, item: hit, components };
              
              // Try to use existing template function
              const templateFunction = window.algoliaShopify.hooks?.getHook('beforeAutocompleteProductTemplate');
              if (templateFunction && templateFunction.length > 0) {
                return templateFunction[0](() => html`<div>Loading...</div>`, templateOptions, distinct, itemLink, false);
              }
            } catch (error) {
              // Silently continue to fallback
            }
            
            // Fallback: Use your existing product card design with proper helpers
            const distinct = window.algoliaShopify?.instantsearch?.distinct || false;
            const itemLink = hit.url || `/products/${hit.handle}`;
            const originalImageAlt = getOriginalImageAltFromItem(hit);
            const titleOnlyFallback =
              (typeof hit?.title === "string" && hit.title.trim()) ||
              (typeof hit?.name === "string" && hit.name.trim()) ||
              "Product";
            const hitAltTagFlag = parseBoolLike(
              hit?.meta?.custom?.product_image_alt_tags ??
                hit?.custom?.product_image_alt_tags ??
                hit?.metafields?.custom?.product_image_alt_tags ??
                hit?.product_image_alt_tags
            );
            const imageAlt = hitAltTagFlag
              ? (originalImageAlt || titleOnlyFallback)
              : buildAlgoliaImageAlt(hit);
            
            return html`
              <a
                href="${itemLink}"
                class="search-page-card"
                data-product-handle="${hit.handle}"
                data-product-id="${hit.objectID}"
                data-variant-id="${hit.variant_id || ''}"
                onClick="${() => trackSearchAttribution(hit)}"
              >
                <!--  Product Image -->
                <div class="aa-ItemPicture">
                  <img src="${hit.image || hit.product_image || hit.image_url || ''}" 
                       alt="${imageAlt}" 
                       loading="lazy"
                       onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
                  <div style="display:none; background:#f5f5f5; width:100%; height:200px; display:flex; align-items:center; justify-content:center; color:#999;">
                    No Image
                  </div>
                </div>

                <div class="aa-ItemContentBody">
                    <!--  Brand / Strapline + Mobile Quick Buy -->
                    <div class="aa-ItemContentHeader">
                      <div class="aa-ItemContentStrapline">${hit.vendor || ""}</div>
                      <button
                        type="button"
                        data-product-handle="${hit.handle}"
                        class="prd-Card_QuickBuyTrigger aa-ItemContentQuickbuyMobile"
                        data-algolia-autocomplete-card-el="mobile-trigger"
                      >
                        <span class="hd-Banner_Icon">
                          <svg
                            id="baoIconBag"
                            viewBox="0 0 18 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1 19H16.75L15.711 6.53157C15.6624 5.9485 15.175 5.5 14.5899 5.5H3.16015C2.57505 5.5 2.08763 5.9485 2.03904 6.53157L1 19Z"
                              stroke="currentColor"
                            ></path>
                            <path
                              fill="transparent"
                              d="M12 7C12 6.24543 12 4.43578 12 2.99988C12 1.89531 11.1046 1 10 1H8.00002C6.89545 1 6.00002 1.89543 6.00002 3V7"
                              stroke="currentColor"
                              stroke-linecap="square"
                            ></path>
                          </svg>
                           <!-- Eye Icon -->
                            <svg
                              id="baoIconEye"
                              class="icon-eye"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7z"
                                stroke="currentColor"
                                stroke-width="2"
                                fill="none"
                              />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
                            </svg>
                        </span>
                      </button>
                    </div>

                  <!--  Title -->
                  <div class="aa-ItemContentTitle">
                    ${components.Highlight({ hit: hit, attribute: "title" })}
                    <span class="algolia-variant">
                      ${window.algoliaShopify?.helpers?.variantTitleAddition ? 
                        window.algoliaShopify.helpers.variantTitleAddition(hit, distinct) : 
                        (hit.variant_title || '')}
                    </span>
                  </div>

                  <!--  Price -->
                  <div class="aa-ItemContentPriceCurrent price">
                    ${(() => {
                      if (window.algoliaShopify?.helpers?.displayPrice) {
                        const priceHtml = window.algoliaShopify.helpers.displayPrice(hit, distinct);
                        // Clean HTML tags and convert Rs. to £
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = priceHtml;
                        const textContent = tempDiv.textContent || tempDiv.innerText || '';
                        return textContent.replace(/Rs\./g, "£").replace(/£\s*([0-9,.]+)\s*-\s*£\s*([0-9,.]+)/g, "From £$1").trim();
                      }
                      return hit.price ? `£${hit.price}` : '';
                    })()}
                  </div>

                    <!--  Trustpilot Star Rating -->
                    <div class="trustpilot-product-rating" data-trustpilot-product="${hit.objectID}">
                      <div class="trustpilot-widget" 
                           data-locale="en-US" 
                           data-template-id="5406e65db0d04a09e042d5fc" 
                           data-businessunit-id="5bf3cd76608c550001c8463c" 
                           data-style-height="28px" 
                           data-style-width="100%" 
                           data-token="2322de43-cadc-44c9-af2d-aa7a6619cb2d">
                        <a href="https://www.trustpilot.com/review/www.widefitshoes.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                      </div>
                    </div>
                </div>
              </a>
            `;
              },
              empty(results, { html }) {
                return html`
                  <div class="no-results">
                    <h3>No results found for "${results.query}"</h3>
                    <p>Try adjusting your search or filters</p>
                  </div>
                `;
              }
            },
            transformItems: items => {
              
              // Transform items following official docs pattern
              return items.map(item => ({
                ...item,
                _distinct: window.algoliaShopify?.instantsearch?.distinct || false,
                can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
                queryID: item._queryID,
                productPosition: item._position,
                index: window.algoliaShopify?.instantsearch?.search?.mainIndex?.getIndexName() || 'products'
              }));
            }
          });

          // Create pagination widget
          const paginationWidget = pagination({
            container: document.querySelector('.ais-pagination-container') || createPaginationContainer(),
            templates: {
              item: `{{#isDisabled}}{{label}}{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link">{{label}}</a>{{/isDisabled}}`,
              previous: `{{#isDisabled}}‹{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--previous">‹</a>{{/isDisabled}}`,
              next: `{{#isDisabled}}›{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--next">›</a>{{/isDisabled}}`,
              first: `{{#isDisabled}}«{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--first">«</a>{{/isDisabled}}`,
              last: `{{#isDisabled}}»{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--last">»</a>{{/isDisabled}}`
            },
            showFirst: false,
            showLast: false,
            showPrevious: true,
            showNext: true,
            padding: 2
          });

          function createPaginationContainer() {
            const container = document.createElement('div');
            container.className = 'ais-pagination-container';
            
            // Try to find a good place to insert pagination
            const hitsContainer = document.querySelector('#hits, .ais-hits-container, .ais-Hits');
            if (hitsContainer) {
              hitsContainer.parentNode.insertBefore(container, hitsContainer.nextSibling);
            } else {
              document.body.appendChild(container);
            }
            
            return container;
          }
          
          
          // Add hits and pagination widgets to filtered widgets
          const finalWidgets = [...filteredWidgets, hitsWidget, paginationWidget];
          
          // Initialize quick view functionality after widgets are rendered
          setTimeout(() => {
           
            initializeQuickViewForHits();
            
          }, 2000); // Delay to ensure widgets are fully rendered
          
          return finalWidgets;
          
        } catch (error) {
          console.error('[Algolia Hits] Error creating hits widget:', error);
          return widgets; // Return original widgets if hits fails
        }
      });
      
      // Set up pagination styling and functionality
      setTimeout(() => {
        // Pagination setup complete
                
        function stylePagination() {
          // Style pagination to match theme design
          const paginationSelectors = [
            '.ais-Pagination',
            '.ais-Pagination-list',
            '.ais-Pagination-item',
            '.ais-Pagination-link'
          ];
          
          paginationSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
              el.style.display = 'block';
              el.style.visibility = 'visible';
            });
          });
          
          // Ensure hits widget is visible
          const hitsWidget = document.querySelector('.ais-Hits');
          if (hitsWidget) {
            hitsWidget.style.display = 'block';
          }
        }
        
        // Style pagination with multiple attempts, but only after hits is ready
        let attempts = 0;
        const maxAttempts = 10;
        
        const checkAndStyle = () => {
          attempts++;
          const hitsWidget = document.querySelector('.ais-Hits');
          
          if (hitsWidget) {
            stylePagination();
            
            // Skeleton loading removed - pagination loads directly
            
            const algoliaElement = document.querySelector('#algolia-shopify-instantsearch');
            if (algoliaElement) {
              algoliaElement.style.opacity = '1';
            }
            
            return; // Stop trying
          }
          
          if (attempts >= maxAttempts) {
            return; // Stop trying
          }
          setTimeout(checkAndStyle, 500);
        };
        
        // Start checking after a delay
        setTimeout(checkAndStyle, 1000);
        
        // Watch for dynamically added pagination and style it
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                  const paginationElements = node.querySelectorAll ? 
                    node.querySelectorAll('.ais-Pagination, .pagination, [class*="pagination"]') : 
                    (node.classList && Array.from(node.classList).some(cls => cls.includes('pagination')) ? [node] : []);
                  
                  paginationElements.forEach(el => {
                    el.style.display = 'block';
                    el.style.visibility = 'visible';
                  });
                }
              });
            }
          });
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }, 1000); // Reduced timeout to prevent conflicts
      
      // Direct approach with shorter timeout
      setTimeout(() => {
        createHitsWithPaginationDirectly();
      }, 1500); // Reduced timeout
      
    } catch (error) {
      console.error('[Algolia Pagination] Error initializing:', error);
    }
  }
  
      // Initialize quick view functionality for hits products
      function initializeQuickViewForHits() {
        
        // Function to attach quick view handlers to products
        function attachQuickViewHandlers() {
          const hitsContainer = document.querySelector('.ais-Hits');
          if (!hitsContainer) return;
          
          // Find all quick buy buttons in hits products
          const quickBuyButtons = hitsContainer.querySelectorAll('.aa-ItemContentQuickbuyMobile');
          
          quickBuyButtons.forEach(button => {
            // Remove existing event listeners to prevent duplicates
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            
            // Add click event listener
            newButton.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const productHandle = this.getAttribute('data-product-handle');
              
              if (productHandle) {
               variantPopup.openPopup(productHandle);
              }
            });
          });
          
        }
        
        // Attach handlers immediately
        attachQuickViewHandlers();
        
        // Simplified MutationObserver for better performance
        const observer = new MutationObserver(function(mutations) {
          let shouldUpdate = false;
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              shouldUpdate = true;
            }
          });
          
          if (shouldUpdate) {
            setTimeout(attachQuickViewHandlers, 50); // Reduced delay
          }
        });
        
        // Observe the hits container
        const hitsContainer = document.querySelector('.ais-Hits');
        if (hitsContainer) {
          observer.observe(hitsContainer, {
            childList: true,
            subtree: true
          });
        }
      }

      // Direct approach to create Hits and Pagination widgets
      function createHitsWithPaginationDirectly() {
    try {
      
      // Check if we already have a Hits widget - early return for performance
      const existingHits = document.querySelector('.ais-Hits');
      if (existingHits && existingHits.children.length > 0) {
        console.log('[Algolia Hits] Widget already exists with content, skipping creation');
        return;
      }
      
      // Check if InstantSearch is available
      if (!window.instantsearch || !window.instantsearch.widgets || !window.instantsearch.widgets.hits || !window.instantsearch.widgets.pagination) {
        return;
      }
      
      // Check if Algolia Shopify search instance is available
      if (!window.algoliaShopify || !window.algoliaShopify.instantsearch || !window.algoliaShopify.instantsearch.search) {
        return;
      }
      
      
      const { hits, pagination } = window.instantsearch.widgets;
      const search = window.algoliaShopify.instantsearch.search;
      
      // Simplified container finding for better performance
      let container = document.querySelector('#hits, .ais-hits-container, .ais-Hits');
      
      if (!container) {
        container = document.createElement('div');
        container.className = 'ais-hits-container';
        container.id = 'hits';
        
        // Simplified placement logic
        const mainContent = document.querySelector('main, .main-content, .page-width');
        if (mainContent) {
          mainContent.appendChild(container);
        } else {
          document.body.appendChild(container);
        }
      }
      
      
      // Create the Hits widget
    
      const hitsWidget = hits({
        container: container,
        templates: {
          item(hit, { html, components }) {            
            // Use your existing product template function directly
            try {
              // Get the distinct setting
              const distinct = window.algoliaShopify?.instantsearch?.distinct || false;
              
              // Create itemLink
              const itemLink = hit.url || `/products/${hit.handle}`;
              const templateOptions = { html, item: hit, components };
            } catch (error) {
              console.log('[Algolia Hits] Error using existing template function in direct widget:', error);
            }
            
            // Fallback: Use your existing product card design with proper helpers
            const distinct = window.algoliaShopify?.instantsearch?.distinct || false;
            const itemLink = hit.url || `/products/${hit.handle}`;
            const imageAlt = buildAlgoliaImageAlt(hit);
            
            return html`
              <a
                href="${itemLink}"
                class="search-page-card"
                data-product-handle="${hit.handle}"
                data-product-id="${hit.objectID}"
                data-variant-id="${hit.variant_id || ''}"
                onClick="${() => trackSearchAttribution(hit)}"
              >
                <!--  Product Image -->
                <div class="aa-ItemPicture">
                  <img src="${hit.image || hit.product_image || hit.image_url || ''}" 
                       alt="${imageAlt}" 
                       loading="lazy"
                       onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
                  <div style="display:none; background:#f5f5f5; width:100%; height:200px; display:flex; align-items:center; justify-content:center; color:#999;">
                    No Image
                  </div>
                </div>

                <div class="aa-ItemContentBody">
                    <!--  Brand / Strapline + Mobile Quick Buy -->
                    <div class="aa-ItemContentHeader">
                      <div class="aa-ItemContentStrapline">${hit.vendor || ""}</div>
                      <button
                        type="button"
                        data-product-handle="${hit.handle}"
                        class="prd-Card_QuickBuyTrigger aa-ItemContentQuickbuyMobile"
                        data-algolia-autocomplete-card-el="mobile-trigger"
                      >
                        <span class="hd-Banner_Icon">
                          <svg
                            id="baoIconBag"
                            viewBox="0 0 18 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1 19H16.75L15.711 6.53157C15.6624 5.9485 15.175 5.5 14.5899 5.5H3.16015C2.57505 5.5 2.08763 5.9485 2.03904 6.53157L1 19Z"
                              stroke="currentColor"
                            ></path>
                            <path
                              fill="transparent"
                              d="M12 7C12 6.24543 12 4.43578 12 2.99988C12 1.89531 11.1046 1 10 1H8.00002C6.89545 1 6.00002 1.89543 6.00002 3V7"
                              stroke="currentColor"
                              stroke-linecap="square"
                            ></path>
                          </svg>
                           <!-- Eye Icon -->
                            <svg
                              id="baoIconEye"
                              class="icon-eye"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <path
                                d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7z"
                                stroke="currentColor"
                                stroke-width="2"
                                fill="none"
                              />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none"/>
                            </svg>
                        </span>
                      </button>
                    </div>

                  <!--  Title -->
                  <div class="aa-ItemContentTitle">
                    ${components.Highlight({ hit: hit, attribute: "title" })}
                    <span class="algolia-variant">
                      ${window.algoliaShopify?.helpers?.variantTitleAddition ? 
                        window.algoliaShopify.helpers.variantTitleAddition(hit, distinct) : 
                        (hit.variant_title || '')}
                    </span>
                  </div>

                  <!--  Price -->
                  <div class="aa-ItemContentPriceCurrent price">
                    ${(() => {
                      if (window.algoliaShopify?.helpers?.displayPrice) {
                        const priceHtml = window.algoliaShopify.helpers.displayPrice(hit, distinct);
                        // Clean HTML tags and convert Rs. to £
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = priceHtml;
                        const textContent = tempDiv.textContent || tempDiv.innerText || '';
                        return textContent.replace(/Rs\./g, "£").replace(/£\s*([0-9,.]+)\s*-\s*£\s*([0-9,.]+)/g, "From £$1").trim();
                      }
                      return hit.price ? `£${hit.price}` : '';
                    })()}
                  </div>

                  <!-- Available Widths -->
                  <div class="available-widths" data-product-handle="${hit.handle}">
                    ${generateWidthsHTML(getAvailableWidthsForProduct(hit.handle, false))}
                  </div>

                    <!--  Trustpilot Star Rating -->
                    <div class="trustpilot-product-rating" data-trustpilot-product="${hit.objectID}">
                      <div class="trustpilot-widget" 
                           data-locale="en-GB" 
                           data-template-id="5419b732fbfb950b10de65e5" 
                           data-businessunit-id="5bf3cd76608c550001c8463c" 
                           data-style-height="20px" 
                           data-style-width="100%" 
                           data-theme="light">
                        <a href="https://uk.trustpilot.com/review/www.widefitshoes.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                      </div>
                    </div>
                </div>
              </a>
            `;
          },
          empty(results, { html }) {
            return html`
              <div class="no-results">
                <h3>No results found for "${results.query}"</h3>
                <p>Try adjusting your search or filters</p>
              </div>
            `;
          }
        },
        transformItems: items => {          
          return items.map(item => ({
            ...item,
            _distinct: window.algoliaShopify?.instantsearch?.distinct || false,
            can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
            queryID: item._queryID,
            productPosition: item._position,
            index: window.algoliaShopify?.instantsearch?.search?.mainIndex?.getIndexName() || 'products'
          }));
        }
      });

      // Create pagination widget
      const paginationWidget = pagination({
        container: document.querySelector('.ais-pagination-container') || createPaginationContainer(),
        templates: {
          item: `{{#isDisabled}}{{label}}{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link">{{label}}</a>{{/isDisabled}}`,
          previous: `{{#isDisabled}}‹{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--previous">‹</a>{{/isDisabled}}`,
          next: `{{#isDisabled}}›{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--next">›</a>{{/isDisabled}}`,
          first: `{{#isDisabled}}«{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--first">«</a>{{/isDisabled}}`,
          last: `{{#isDisabled}}»{{/isDisabled}}{{^isDisabled}}<a href="{{url}}" class="ais-Pagination-link ais-Pagination-link--last">»</a>{{/isDisabled}}`
        },
        showFirst: false,
        showLast: false,
        showPrevious: true,
        showNext: true,
        padding: 2
      });

      function createPaginationContainer() {
        const container = document.createElement('div');
        container.className = 'ais-pagination-container';
        
        // Try to find a good place to insert pagination
        const hitsContainer = document.querySelector('#hits, .ais-hits-container, .ais-Hits');
        if (hitsContainer) {
          hitsContainer.parentNode.insertBefore(container, hitsContainer.nextSibling);
        } else {
          document.body.appendChild(container);
        }
        
        return container;
      }
            
          // Add the widgets to the search instance
          search.addWidgets([hitsWidget, paginationWidget]);
          initializeQuickViewForHits();
      setTimeout(() => {
        // Ensure hits and pagination are visible
        const hitsElements = document.querySelectorAll('.ais-Hits');
        hitsElements.forEach(hits => {
          hits.style.display = 'block';
        });
        
        // Show pagination
        const paginationElements = document.querySelectorAll('.ais-Pagination, .pagination, [class*="pagination"]');
        paginationElements.forEach(el => {
          el.style.display = 'block';
          el.style.visibility = 'visible';
        });
      }, 1000);
      
    } catch (error) {
      console.error('[Algolia Hits] Error in direct widget creation:', error);
    }
  }
  
  // Helper function to clean price display
  function cleanPriceDisplay(priceString) {
    if (!priceString) return '';
    
    // If it contains HTML tags, extract text content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = priceString;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    // Convert Rs. to £ and clean up the display
    return textContent.replace(/Rs\./g, "£").replace(/£\s*([0-9,.]+)\s*-\s*£\s*([0-9,.]+)/g, "From £$1").trim();
  }

  // Start initialization with slight delay to ensure DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePagination);
  } else {
    setTimeout(initializePagination, 100); // Small delay for better performance
  }
})();

// Enhance existing Recommend sections after load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(processAlgoliaRecommendCards, 300);
  });
} else {
  setTimeout(processAlgoliaRecommendCards, 300);
}

// Dynamic header height detection for search panel positioning
function updateSearchPanelPosition() {
  const searchPanel = document.querySelector('.aa-Panel');
  if (!searchPanel) return;
  
  // Check if header is stuck (scrolled) by looking for the stuck header element
  const stuckHeader = document.querySelector('.site-header.site-header--stuck.site-header--opening');
  const isHeaderStuck = stuckHeader && stuckHeader.offsetHeight > 0;
  
  // Alternative method: check if we're scrolled down enough
  const scrollY = window.scrollY || window.pageYOffset;
  const isScrolled = scrollY > 50; // Adjust threshold as needed
  
  if (isHeaderStuck || isScrolled) {
    searchPanel.classList.add('header-stuck');
    document.body.style.overflow = 'hidden';
  } else {
    searchPanel.classList.remove('header-stuck');
    document.body.style.overflow = 'auto';
  }
  
  // Ensure body overflow is hidden when search panel is visible
  if(window.innerWidth > 990){
  if (searchPanel && searchPanel.offsetParent !== null) {
    document.body.style.overflow = 'hidden';
  }
}
}

// Listen for scroll events to update panel position
let scrollTimeout;
window.addEventListener('scroll', function() {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(updateSearchPanelPosition, 10);
});

// Search panel positioning is now handled by the consolidated searchPanelObserver above

// Initial check
updateSearchPanelPosition();

// Handle clicks on hd-Banner_Icon buttons
document.addEventListener('click', (e) => {
  if (e.target.closest('.hd-Banner_Icon')) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.target.closest('button');
    const productHandle = button?.dataset.productHandle;
    
    if (productHandle) {
      variantPopup.openPopup(productHandle);
    }
  }
});

// Handle drag scroll for product cards - dynamic approach
let isDown = false;
let startX;
let scrollLeft;
let currentProductList = null;

// Use event delegation to handle dynamically created elements
document.addEventListener('mousedown', (e) => {
  const productList = e.target.closest('.aa-PanelSection--right .aa-List');
  if (productList) {
    isDown = true;
    currentProductList = productList;
    productList.classList.add("dragging");
    startX = e.pageX - productList.offsetLeft;
    scrollLeft = productList.scrollLeft;
    e.preventDefault();
  }
});

document.addEventListener('mouseleave', () => {
  if (isDown && currentProductList) {
    isDown = false;
    currentProductList.classList.remove("dragging");
    currentProductList = null;
  }
});

document.addEventListener('mouseup', () => {
  if (isDown && currentProductList) {
    isDown = false;
    currentProductList.classList.remove("dragging");
    currentProductList = null;
  }
});

document.addEventListener('mousemove', (e) => {
  if (!isDown || !currentProductList) return;
  e.preventDefault();
  const x = e.pageX - currentProductList.offsetLeft;
  const walk = (x - startX) * 1.5; // scroll speed
  currentProductList.scrollLeft = scrollLeft - walk;
});



// Duplicate stats container for mobile sticky positioning
function createDuplicateStatsContainer() {
  const indexSection = document.querySelector('.index-section');
  
  // Try multiple selectors to find stats element
  const possibleSelectors = [
    '.ais-stats-container',
    '.ais-page .ais-Stats', 
    '.ais-Stats',
    '.ais-h2',
    '.ais-page h1',
    '.ais-page h2',
    '[class*="stats"]',
    '[class*="Stats"]'
  ];
  
  // Helper function to find stats element
  function findStatsElement() {
    for (const selector of possibleSelectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }
    return null;
  }
  
  const originalStats = findStatsElement();
  
  if (!indexSection) {
    setTimeout(createDuplicateStatsContainer, 500);
    return;
  }

  if (!originalStats) {
    setTimeout(createDuplicateStatsContainer, 500);
    return;
  }

  // Check if duplicate already exists
  if (document.getElementById('algolia-duplicate-stats')) {
    return;
  }

  // Create duplicate stats container
  const duplicateStats = originalStats.cloneNode(true);
  duplicateStats.id = 'algolia-duplicate-stats';
  duplicateStats.className = 'algolia-duplicate-stats-container';
  
  // Insert as first child of .index-section
  indexSection.insertBefore(duplicateStats, indexSection.firstChild);
  
  // Function to update duplicate stats content
  function updateDuplicateStats() {
    const originalStats = findStatsElement();
    const duplicateStats = document.getElementById('algolia-duplicate-stats');
    
    if (originalStats && duplicateStats) {
      // Update content
      duplicateStats.innerHTML = originalStats.innerHTML;
    }
  }

  // Initial update
  updateDuplicateStats();

  // Listen for Algolia state changes to update stats
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        // Check if stats content has changed
        const originalStats = findStatsElement();
        
        // Check if mutation.target is an Element (not TextNode) before using closest()
        if (originalStats && mutation.target && mutation.target.nodeType === Node.ELEMENT_NODE) {
          if (mutation.target.closest('.ais-stats-container, .ais-Stats, .ais-h2, .ais-page h1, .ais-page h2')) {
            updateDuplicateStats();
          }
        } else if (originalStats && mutation.target && mutation.target.parentElement) {
          // If it's a TextNode, check parent element
          if (mutation.target.parentElement.closest('.ais-stats-container, .ais-Stats, .ais-h2, .ais-page h1, .ais-page h2')) {
            updateDuplicateStats();
          }
        }
      }
    });
  });

  // Observe the original stats container for changes
  const statsElement = findStatsElement();
  
  if (statsElement) {
    observer.observe(statsElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Also listen for Algolia search events
  document.addEventListener('DOMContentLoaded', function() {
    if (window.algolia && window.algolia.instantsearch) {
      window.algolia.instantsearch.on('render', function() {
        setTimeout(updateDuplicateStats, 100);
      });
    }
  });

}

// Function to close all range slider accordions by default
function closeRangeSliderAccordions() {
  document.querySelectorAll('.ais-range-slider--header').forEach(ele=>ele.click());
}

// Global function to recreate duplicate stats container
let recreateTimeout = null;
function recreateDuplicateStatsContainer() {
  // Clear any existing timeout to debounce multiple calls
  if (recreateTimeout) {
    clearTimeout(recreateTimeout);
  }
  
  recreateTimeout = setTimeout(() => {
    // Remove existing duplicate if it exists
    const existingDuplicate = document.getElementById('algolia-duplicate-stats');
    if (existingDuplicate) {
      existingDuplicate.remove();
    }
    // Create new duplicate
    createDuplicateStatsContainer();
  }, 200);
}

// Call the function
createDuplicateStatsContainer();

// Listen for Algolia state changes to recreate duplicate stats
document.addEventListener('DOMContentLoaded', function() {
  // Listen for filter changes, search updates, etc.
  const algoliaObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if stats content changed or new search results loaded
        const hasStatsChange = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === Node.ELEMENT_NODE && 
          (node.classList?.contains('ais-Stats') || 
           node.querySelector?.('.ais-Stats') ||
           node.classList?.contains('ais-h2') ||
           node.querySelector?.('.ais-h2')) &&
          !node.id?.includes('algolia-duplicate-stats') // Don't trigger on our own duplicate
        );
        
        if (hasStatsChange) {
          recreateDuplicateStatsContainer();
        }
      }
    });
  });
  
  // Observe the Algolia container for changes
  const algoliaContainer = document.querySelector('#algolia-shopify-instantsearch, .ais-page, .ais-block');
  if (algoliaContainer) {
    algoliaObserver.observe(algoliaContainer, {
      childList: true,
      subtree: true
    });
  }
  
});

